/* 此文件由 scripts/process-assets.mjs 自动生成，请勿手动编辑。 */

export type CategoryId =
  | 'architecture'
  | 'money-trees'
  | 'wealth'
  | 'transport'
  | 'home-life'
  | 'ceremonial'
  | 'sets';

export interface Category {
  readonly id: CategoryId;
  readonly name: string;
  readonly count: number;
}

export interface ImageSource {
  readonly src: string;
  readonly width: number;
  readonly height: number;
}

export interface ProductImage {
  readonly label: string;
  readonly alt: string;
  readonly width: number;
  readonly height: number;
  readonly src: string;
  readonly srcSet: string;
  readonly sources: readonly ImageSource[];
}

export interface Product {
  readonly id: string;
  readonly name: string;
  readonly categoryId: CategoryId;
  readonly sourceDirectory: string;
  readonly images: readonly ProductImage[];
}

// CATALOG_DATA_START
const catalogData = {
  "categories": [
    {
      "id": "architecture",
      "name": "楼房宅院",
      "count": 10
    },
    {
      "id": "money-trees",
      "name": "摇钱树·聚宝盆",
      "count": 10
    },
    {
      "id": "wealth",
      "name": "金山钱粮·财富摆件",
      "count": 20
    },
    {
      "id": "transport",
      "name": "车驾出行",
      "count": 3
    },
    {
      "id": "home-life",
      "name": "家电生活用品",
      "count": 8
    },
    {
      "id": "ceremonial",
      "name": "花灯人物·礼仪摆件",
      "count": 5
    },
    {
      "id": "sets",
      "name": "组合套装",
      "count": 1
    }
  ],
  "products": [
    {
      "id": "product-001",
      "name": "豪华大别墅",
      "categoryId": "architecture",
      "sourceDirectory": "豪华大别墅",
      "images": [
        {
          "label": "正面",
          "alt": "豪华大别墅，正面实拍图",
          "width": 1600,
          "height": 2132,
          "src": "/products/product-001/image-01-960-9a2e2af30fb0.webp",
          "srcSet": "/products/product-001/image-01-480-d1a71ed994cf.webp 480w, /products/product-001/image-01-960-9a2e2af30fb0.webp 960w, /products/product-001/image-01-1600-8a8b3fce2a98.webp 1600w",
          "sources": [
            {
              "src": "/products/product-001/image-01-480-d1a71ed994cf.webp",
              "width": 480,
              "height": 640
            },
            {
              "src": "/products/product-001/image-01-960-9a2e2af30fb0.webp",
              "width": 960,
              "height": 1279
            },
            {
              "src": "/products/product-001/image-01-1600-8a8b3fce2a98.webp",
              "width": 1600,
              "height": 2132
            }
          ]
        }
      ]
    },
    {
      "id": "product-002",
      "name": "豪华过街楼",
      "categoryId": "architecture",
      "sourceDirectory": "豪华过街楼",
      "images": [
        {
          "label": "正面",
          "alt": "豪华过街楼，正面实拍图",
          "width": 1600,
          "height": 2133,
          "src": "/products/product-002/image-01-960-1725b0a3d3e4.webp",
          "srcSet": "/products/product-002/image-01-480-92be5c8a24a7.webp 480w, /products/product-002/image-01-960-1725b0a3d3e4.webp 960w, /products/product-002/image-01-1600-27abecd87e2c.webp 1600w",
          "sources": [
            {
              "src": "/products/product-002/image-01-480-92be5c8a24a7.webp",
              "width": 480,
              "height": 640
            },
            {
              "src": "/products/product-002/image-01-960-1725b0a3d3e4.webp",
              "width": 960,
              "height": 1280
            },
            {
              "src": "/products/product-002/image-01-1600-27abecd87e2c.webp",
              "width": 1600,
              "height": 2133
            }
          ]
        }
      ]
    },
    {
      "id": "product-003",
      "name": "小两层过街楼",
      "categoryId": "architecture",
      "sourceDirectory": "小两层过街楼",
      "images": [
        {
          "label": "正面",
          "alt": "小两层过街楼，正面实拍图",
          "width": 1600,
          "height": 2133,
          "src": "/products/product-003/image-01-960-65060e9568b6.webp",
          "srcSet": "/products/product-003/image-01-480-1d79ac0587a5.webp 480w, /products/product-003/image-01-960-65060e9568b6.webp 960w, /products/product-003/image-01-1600-9f72195f4ad9.webp 1600w",
          "sources": [
            {
              "src": "/products/product-003/image-01-480-1d79ac0587a5.webp",
              "width": 480,
              "height": 640
            },
            {
              "src": "/products/product-003/image-01-960-65060e9568b6.webp",
              "width": 960,
              "height": 1280
            },
            {
              "src": "/products/product-003/image-01-1600-9f72195f4ad9.webp",
              "width": 1600,
              "height": 2133
            }
          ]
        }
      ]
    },
    {
      "id": "product-004",
      "name": "三层别墅",
      "categoryId": "architecture",
      "sourceDirectory": "三层别墅",
      "images": [
        {
          "label": "正面",
          "alt": "三层别墅，正面实拍图",
          "width": 1600,
          "height": 2133,
          "src": "/products/product-004/image-01-960-877d9faff650.webp",
          "srcSet": "/products/product-004/image-01-480-c1a249edc20b.webp 480w, /products/product-004/image-01-960-877d9faff650.webp 960w, /products/product-004/image-01-1600-cc8d5c4efc68.webp 1600w",
          "sources": [
            {
              "src": "/products/product-004/image-01-480-c1a249edc20b.webp",
              "width": 480,
              "height": 640
            },
            {
              "src": "/products/product-004/image-01-960-877d9faff650.webp",
              "width": 960,
              "height": 1280
            },
            {
              "src": "/products/product-004/image-01-1600-cc8d5c4efc68.webp",
              "width": 1600,
              "height": 2133
            }
          ]
        },
        {
          "label": "侧面",
          "alt": "三层别墅，侧面实拍图",
          "width": 1600,
          "height": 1200,
          "src": "/products/product-004/image-02-960-db10ee72fe29.webp",
          "srcSet": "/products/product-004/image-02-480-e1d628a1fc51.webp 480w, /products/product-004/image-02-960-db10ee72fe29.webp 960w, /products/product-004/image-02-1600-d3c70a509488.webp 1600w",
          "sources": [
            {
              "src": "/products/product-004/image-02-480-e1d628a1fc51.webp",
              "width": 480,
              "height": 360
            },
            {
              "src": "/products/product-004/image-02-960-db10ee72fe29.webp",
              "width": 960,
              "height": 720
            },
            {
              "src": "/products/product-004/image-02-1600-d3c70a509488.webp",
              "width": 1600,
              "height": 1200
            }
          ]
        }
      ]
    },
    {
      "id": "product-005",
      "name": "普通款三层别墅",
      "categoryId": "architecture",
      "sourceDirectory": "普通款三层别墅",
      "images": [
        {
          "label": "正面",
          "alt": "普通款三层别墅，正面实拍图",
          "width": 1600,
          "height": 2133,
          "src": "/products/product-005/image-01-960-8390232ec982.webp",
          "srcSet": "/products/product-005/image-01-480-24e203b3d650.webp 480w, /products/product-005/image-01-960-8390232ec982.webp 960w, /products/product-005/image-01-1600-c7e390645bdf.webp 1600w",
          "sources": [
            {
              "src": "/products/product-005/image-01-480-24e203b3d650.webp",
              "width": 480,
              "height": 640
            },
            {
              "src": "/products/product-005/image-01-960-8390232ec982.webp",
              "width": 960,
              "height": 1280
            },
            {
              "src": "/products/product-005/image-01-1600-c7e390645bdf.webp",
              "width": 1600,
              "height": 2133
            }
          ]
        },
        {
          "label": "侧面",
          "alt": "普通款三层别墅，侧面实拍图",
          "width": 1600,
          "height": 2133,
          "src": "/products/product-005/image-02-960-e39fcdc7ff7d.webp",
          "srcSet": "/products/product-005/image-02-480-7d9b23224405.webp 480w, /products/product-005/image-02-960-e39fcdc7ff7d.webp 960w, /products/product-005/image-02-1600-2a97d6e763f4.webp 1600w",
          "sources": [
            {
              "src": "/products/product-005/image-02-480-7d9b23224405.webp",
              "width": 480,
              "height": 640
            },
            {
              "src": "/products/product-005/image-02-960-e39fcdc7ff7d.webp",
              "width": 960,
              "height": 1280
            },
            {
              "src": "/products/product-005/image-02-1600-2a97d6e763f4.webp",
              "width": 1600,
              "height": 2133
            }
          ]
        }
      ]
    },
    {
      "id": "product-006",
      "name": "两层楼",
      "categoryId": "architecture",
      "sourceDirectory": "两层楼",
      "images": [
        {
          "label": "正面",
          "alt": "两层楼，正面实拍图",
          "width": 1600,
          "height": 1600,
          "src": "/products/product-006/image-01-960-f1e4a454196f.webp",
          "srcSet": "/products/product-006/image-01-480-37535bf9ca2a.webp 480w, /products/product-006/image-01-960-f1e4a454196f.webp 960w, /products/product-006/image-01-1600-305dcf558db7.webp 1600w",
          "sources": [
            {
              "src": "/products/product-006/image-01-480-37535bf9ca2a.webp",
              "width": 480,
              "height": 480
            },
            {
              "src": "/products/product-006/image-01-960-f1e4a454196f.webp",
              "width": 960,
              "height": 960
            },
            {
              "src": "/products/product-006/image-01-1600-305dcf558db7.webp",
              "width": 1600,
              "height": 1600
            }
          ]
        }
      ]
    },
    {
      "id": "product-007",
      "name": "两层四合院",
      "categoryId": "architecture",
      "sourceDirectory": "两层四合院",
      "images": [
        {
          "label": "正面",
          "alt": "两层四合院，正面实拍图",
          "width": 1600,
          "height": 1200,
          "src": "/products/product-007/image-01-960-f5244ffd3b25.webp",
          "srcSet": "/products/product-007/image-01-480-9d9c7577d36c.webp 480w, /products/product-007/image-01-960-f5244ffd3b25.webp 960w, /products/product-007/image-01-1600-48141ce0b53e.webp 1600w",
          "sources": [
            {
              "src": "/products/product-007/image-01-480-9d9c7577d36c.webp",
              "width": 480,
              "height": 360
            },
            {
              "src": "/products/product-007/image-01-960-f5244ffd3b25.webp",
              "width": 960,
              "height": 720
            },
            {
              "src": "/products/product-007/image-01-1600-48141ce0b53e.webp",
              "width": 1600,
              "height": 1200
            }
          ]
        },
        {
          "label": "侧面",
          "alt": "两层四合院，侧面实拍图",
          "width": 1600,
          "height": 1200,
          "src": "/products/product-007/image-02-960-f0c6a30fdb1a.webp",
          "srcSet": "/products/product-007/image-02-480-e01cff59b1f5.webp 480w, /products/product-007/image-02-960-f0c6a30fdb1a.webp 960w, /products/product-007/image-02-1600-05f75696a44d.webp 1600w",
          "sources": [
            {
              "src": "/products/product-007/image-02-480-e01cff59b1f5.webp",
              "width": 480,
              "height": 360
            },
            {
              "src": "/products/product-007/image-02-960-f0c6a30fdb1a.webp",
              "width": 960,
              "height": 720
            },
            {
              "src": "/products/product-007/image-02-1600-05f75696a44d.webp",
              "width": 1600,
              "height": 1200
            }
          ]
        }
      ]
    },
    {
      "id": "product-008",
      "name": "三层楼",
      "categoryId": "architecture",
      "sourceDirectory": "三层楼",
      "images": [
        {
          "label": "正面",
          "alt": "三层楼，正面实拍图",
          "width": 1600,
          "height": 1600,
          "src": "/products/product-008/image-01-960-f2004ba36a70.webp",
          "srcSet": "/products/product-008/image-01-480-14a9ba386d18.webp 480w, /products/product-008/image-01-960-f2004ba36a70.webp 960w, /products/product-008/image-01-1600-06cb122d84dd.webp 1600w",
          "sources": [
            {
              "src": "/products/product-008/image-01-480-14a9ba386d18.webp",
              "width": 480,
              "height": 480
            },
            {
              "src": "/products/product-008/image-01-960-f2004ba36a70.webp",
              "width": 960,
              "height": 960
            },
            {
              "src": "/products/product-008/image-01-1600-06cb122d84dd.webp",
              "width": 1600,
              "height": 1600
            }
          ]
        }
      ]
    },
    {
      "id": "product-009",
      "name": "仙家楼",
      "categoryId": "architecture",
      "sourceDirectory": "仙家楼",
      "images": [
        {
          "label": "正面",
          "alt": "仙家楼，正面实拍图",
          "width": 1600,
          "height": 1200,
          "src": "/products/product-009/image-01-960-5e3dbb89a584.webp",
          "srcSet": "/products/product-009/image-01-480-fe4104fa40ef.webp 480w, /products/product-009/image-01-960-5e3dbb89a584.webp 960w, /products/product-009/image-01-1600-d1c2c351be2f.webp 1600w",
          "sources": [
            {
              "src": "/products/product-009/image-01-480-fe4104fa40ef.webp",
              "width": 480,
              "height": 360
            },
            {
              "src": "/products/product-009/image-01-960-5e3dbb89a584.webp",
              "width": 960,
              "height": 720
            },
            {
              "src": "/products/product-009/image-01-1600-d1c2c351be2f.webp",
              "width": 1600,
              "height": 1200
            }
          ]
        },
        {
          "label": "侧面",
          "alt": "仙家楼，侧面实拍图",
          "width": 1600,
          "height": 2133,
          "src": "/products/product-009/image-02-960-e118cd53431a.webp",
          "srcSet": "/products/product-009/image-02-480-86a559a50ad8.webp 480w, /products/product-009/image-02-960-e118cd53431a.webp 960w, /products/product-009/image-02-1600-4b7bc91a67df.webp 1600w",
          "sources": [
            {
              "src": "/products/product-009/image-02-480-86a559a50ad8.webp",
              "width": 480,
              "height": 640
            },
            {
              "src": "/products/product-009/image-02-960-e118cd53431a.webp",
              "width": 960,
              "height": 1280
            },
            {
              "src": "/products/product-009/image-02-1600-4b7bc91a67df.webp",
              "width": 1600,
              "height": 2133
            }
          ]
        }
      ]
    },
    {
      "id": "product-010",
      "name": "小型别墅",
      "categoryId": "architecture",
      "sourceDirectory": "小型别墅",
      "images": [
        {
          "label": "正面",
          "alt": "小型别墅，正面实拍图",
          "width": 1600,
          "height": 1200,
          "src": "/products/product-010/image-01-960-70516182ccb8.webp",
          "srcSet": "/products/product-010/image-01-480-2bcec76cd978.webp 480w, /products/product-010/image-01-960-70516182ccb8.webp 960w, /products/product-010/image-01-1600-905656989c53.webp 1600w",
          "sources": [
            {
              "src": "/products/product-010/image-01-480-2bcec76cd978.webp",
              "width": 480,
              "height": 360
            },
            {
              "src": "/products/product-010/image-01-960-70516182ccb8.webp",
              "width": 960,
              "height": 720
            },
            {
              "src": "/products/product-010/image-01-1600-905656989c53.webp",
              "width": 1600,
              "height": 1200
            }
          ]
        },
        {
          "label": "侧面",
          "alt": "小型别墅，侧面实拍图",
          "width": 1600,
          "height": 1200,
          "src": "/products/product-010/image-02-960-cea0aef7f8bd.webp",
          "srcSet": "/products/product-010/image-02-480-62d40c1f619a.webp 480w, /products/product-010/image-02-960-cea0aef7f8bd.webp 960w, /products/product-010/image-02-1600-d6851cc95634.webp 1600w",
          "sources": [
            {
              "src": "/products/product-010/image-02-480-62d40c1f619a.webp",
              "width": 480,
              "height": 360
            },
            {
              "src": "/products/product-010/image-02-960-cea0aef7f8bd.webp",
              "width": 960,
              "height": 720
            },
            {
              "src": "/products/product-010/image-02-1600-d6851cc95634.webp",
              "width": 1600,
              "height": 1200
            }
          ]
        }
      ]
    },
    {
      "id": "product-011",
      "name": "彩摇钱树款式1",
      "categoryId": "money-trees",
      "sourceDirectory": "彩摇钱树款式1",
      "images": [
        {
          "label": "正面",
          "alt": "彩摇钱树款式1，正面实拍图",
          "width": 1600,
          "height": 2133,
          "src": "/products/product-011/image-01-960-c36cdcddcf56.webp",
          "srcSet": "/products/product-011/image-01-480-57175109514b.webp 480w, /products/product-011/image-01-960-c36cdcddcf56.webp 960w, /products/product-011/image-01-1600-721528d1a6e4.webp 1600w",
          "sources": [
            {
              "src": "/products/product-011/image-01-480-57175109514b.webp",
              "width": 480,
              "height": 640
            },
            {
              "src": "/products/product-011/image-01-960-c36cdcddcf56.webp",
              "width": 960,
              "height": 1280
            },
            {
              "src": "/products/product-011/image-01-1600-721528d1a6e4.webp",
              "width": 1600,
              "height": 2133
            }
          ]
        },
        {
          "label": "侧面",
          "alt": "彩摇钱树款式1，侧面实拍图",
          "width": 1600,
          "height": 2133,
          "src": "/products/product-011/image-02-960-d165e44aaed8.webp",
          "srcSet": "/products/product-011/image-02-480-27c298ebe492.webp 480w, /products/product-011/image-02-960-d165e44aaed8.webp 960w, /products/product-011/image-02-1600-78889e90b932.webp 1600w",
          "sources": [
            {
              "src": "/products/product-011/image-02-480-27c298ebe492.webp",
              "width": 480,
              "height": 640
            },
            {
              "src": "/products/product-011/image-02-960-d165e44aaed8.webp",
              "width": 960,
              "height": 1280
            },
            {
              "src": "/products/product-011/image-02-1600-78889e90b932.webp",
              "width": 1600,
              "height": 2133
            }
          ]
        }
      ]
    },
    {
      "id": "product-012",
      "name": "彩摇钱树款式2",
      "categoryId": "money-trees",
      "sourceDirectory": "彩摇钱树款式2",
      "images": [
        {
          "label": "正面",
          "alt": "彩摇钱树款式2，正面实拍图",
          "width": 1600,
          "height": 2133,
          "src": "/products/product-012/image-01-960-eabe57e5c82c.webp",
          "srcSet": "/products/product-012/image-01-480-033073b9c0ea.webp 480w, /products/product-012/image-01-960-eabe57e5c82c.webp 960w, /products/product-012/image-01-1600-3f1ae3c4544f.webp 1600w",
          "sources": [
            {
              "src": "/products/product-012/image-01-480-033073b9c0ea.webp",
              "width": 480,
              "height": 640
            },
            {
              "src": "/products/product-012/image-01-960-eabe57e5c82c.webp",
              "width": 960,
              "height": 1280
            },
            {
              "src": "/products/product-012/image-01-1600-3f1ae3c4544f.webp",
              "width": 1600,
              "height": 2133
            }
          ]
        },
        {
          "label": "侧面",
          "alt": "彩摇钱树款式2，侧面实拍图",
          "width": 1600,
          "height": 2133,
          "src": "/products/product-012/image-02-960-2e18c6dd5cda.webp",
          "srcSet": "/products/product-012/image-02-480-1f1ad12e6e5b.webp 480w, /products/product-012/image-02-960-2e18c6dd5cda.webp 960w, /products/product-012/image-02-1600-7939c57e2469.webp 1600w",
          "sources": [
            {
              "src": "/products/product-012/image-02-480-1f1ad12e6e5b.webp",
              "width": 480,
              "height": 640
            },
            {
              "src": "/products/product-012/image-02-960-2e18c6dd5cda.webp",
              "width": 960,
              "height": 1280
            },
            {
              "src": "/products/product-012/image-02-1600-7939c57e2469.webp",
              "width": 1600,
              "height": 2133
            }
          ]
        }
      ]
    },
    {
      "id": "product-013",
      "name": "豪华款聚宝盆",
      "categoryId": "money-trees",
      "sourceDirectory": "豪华款聚宝盆",
      "images": [
        {
          "label": "正面",
          "alt": "豪华款聚宝盆，正面实拍图",
          "width": 1600,
          "height": 2133,
          "src": "/products/product-013/image-01-960-75ad4bfa814e.webp",
          "srcSet": "/products/product-013/image-01-480-6c2956bdc800.webp 480w, /products/product-013/image-01-960-75ad4bfa814e.webp 960w, /products/product-013/image-01-1600-0132d963a08b.webp 1600w",
          "sources": [
            {
              "src": "/products/product-013/image-01-480-6c2956bdc800.webp",
              "width": 480,
              "height": 640
            },
            {
              "src": "/products/product-013/image-01-960-75ad4bfa814e.webp",
              "width": 960,
              "height": 1280
            },
            {
              "src": "/products/product-013/image-01-1600-0132d963a08b.webp",
              "width": 1600,
              "height": 2133
            }
          ]
        },
        {
          "label": "侧面",
          "alt": "豪华款聚宝盆，侧面实拍图",
          "width": 1600,
          "height": 2133,
          "src": "/products/product-013/image-02-960-b6a5b57214e9.webp",
          "srcSet": "/products/product-013/image-02-480-aa882fc3ae32.webp 480w, /products/product-013/image-02-960-b6a5b57214e9.webp 960w, /products/product-013/image-02-1600-cccc84b62748.webp 1600w",
          "sources": [
            {
              "src": "/products/product-013/image-02-480-aa882fc3ae32.webp",
              "width": 480,
              "height": 640
            },
            {
              "src": "/products/product-013/image-02-960-b6a5b57214e9.webp",
              "width": 960,
              "height": 1280
            },
            {
              "src": "/products/product-013/image-02-1600-cccc84b62748.webp",
              "width": 1600,
              "height": 2133
            }
          ]
        }
      ]
    },
    {
      "id": "product-014",
      "name": "豪华款聚宝盆款式2",
      "categoryId": "money-trees",
      "sourceDirectory": "豪华款聚宝盆款式2",
      "images": [
        {
          "label": "正面",
          "alt": "豪华款聚宝盆款式2，正面实拍图",
          "width": 1600,
          "height": 2133,
          "src": "/products/product-014/image-01-960-ff91846dff2a.webp",
          "srcSet": "/products/product-014/image-01-480-4c0273d2fa71.webp 480w, /products/product-014/image-01-960-ff91846dff2a.webp 960w, /products/product-014/image-01-1600-360889aadd2a.webp 1600w",
          "sources": [
            {
              "src": "/products/product-014/image-01-480-4c0273d2fa71.webp",
              "width": 480,
              "height": 640
            },
            {
              "src": "/products/product-014/image-01-960-ff91846dff2a.webp",
              "width": 960,
              "height": 1280
            },
            {
              "src": "/products/product-014/image-01-1600-360889aadd2a.webp",
              "width": 1600,
              "height": 2133
            }
          ]
        },
        {
          "label": "侧面",
          "alt": "豪华款聚宝盆款式2，侧面实拍图",
          "width": 1600,
          "height": 2133,
          "src": "/products/product-014/image-02-960-578f4142174b.webp",
          "srcSet": "/products/product-014/image-02-480-906cfed379bf.webp 480w, /products/product-014/image-02-960-578f4142174b.webp 960w, /products/product-014/image-02-1600-589df21848cf.webp 1600w",
          "sources": [
            {
              "src": "/products/product-014/image-02-480-906cfed379bf.webp",
              "width": 480,
              "height": 640
            },
            {
              "src": "/products/product-014/image-02-960-578f4142174b.webp",
              "width": 960,
              "height": 1280
            },
            {
              "src": "/products/product-014/image-02-1600-589df21848cf.webp",
              "width": 1600,
              "height": 2133
            }
          ]
        }
      ]
    },
    {
      "id": "product-015",
      "name": "豪华款摇钱树",
      "categoryId": "money-trees",
      "sourceDirectory": "豪华款摇钱树",
      "images": [
        {
          "label": "正面",
          "alt": "豪华款摇钱树，正面实拍图",
          "width": 1600,
          "height": 2133,
          "src": "/products/product-015/image-01-960-6e4cfbea252d.webp",
          "srcSet": "/products/product-015/image-01-480-303746c688b6.webp 480w, /products/product-015/image-01-960-6e4cfbea252d.webp 960w, /products/product-015/image-01-1600-94081e98f186.webp 1600w",
          "sources": [
            {
              "src": "/products/product-015/image-01-480-303746c688b6.webp",
              "width": 480,
              "height": 640
            },
            {
              "src": "/products/product-015/image-01-960-6e4cfbea252d.webp",
              "width": 960,
              "height": 1280
            },
            {
              "src": "/products/product-015/image-01-1600-94081e98f186.webp",
              "width": 1600,
              "height": 2133
            }
          ]
        },
        {
          "label": "侧面",
          "alt": "豪华款摇钱树，侧面实拍图",
          "width": 1600,
          "height": 2133,
          "src": "/products/product-015/image-02-960-8f82a1e59edc.webp",
          "srcSet": "/products/product-015/image-02-480-561566d7d5b6.webp 480w, /products/product-015/image-02-960-8f82a1e59edc.webp 960w, /products/product-015/image-02-1600-cb0a70f2f806.webp 1600w",
          "sources": [
            {
              "src": "/products/product-015/image-02-480-561566d7d5b6.webp",
              "width": 480,
              "height": 640
            },
            {
              "src": "/products/product-015/image-02-960-8f82a1e59edc.webp",
              "width": 960,
              "height": 1280
            },
            {
              "src": "/products/product-015/image-02-1600-cb0a70f2f806.webp",
              "width": 1600,
              "height": 2133
            }
          ]
        }
      ]
    },
    {
      "id": "product-016",
      "name": "普通款摇钱树聚宝盆",
      "categoryId": "money-trees",
      "sourceDirectory": "普通款摇钱树聚宝盆",
      "images": [
        {
          "label": "正面",
          "alt": "普通款摇钱树聚宝盆，正面实拍图",
          "width": 1600,
          "height": 2133,
          "src": "/products/product-016/image-01-960-da8d3aa4a884.webp",
          "srcSet": "/products/product-016/image-01-480-ea65a5251936.webp 480w, /products/product-016/image-01-960-da8d3aa4a884.webp 960w, /products/product-016/image-01-1600-01963fd79f23.webp 1600w",
          "sources": [
            {
              "src": "/products/product-016/image-01-480-ea65a5251936.webp",
              "width": 480,
              "height": 640
            },
            {
              "src": "/products/product-016/image-01-960-da8d3aa4a884.webp",
              "width": 960,
              "height": 1280
            },
            {
              "src": "/products/product-016/image-01-1600-01963fd79f23.webp",
              "width": 1600,
              "height": 2133
            }
          ]
        },
        {
          "label": "侧面",
          "alt": "普通款摇钱树聚宝盆，侧面实拍图",
          "width": 1600,
          "height": 1200,
          "src": "/products/product-016/image-02-960-3ec1ead74b45.webp",
          "srcSet": "/products/product-016/image-02-480-0719acd902c8.webp 480w, /products/product-016/image-02-960-3ec1ead74b45.webp 960w, /products/product-016/image-02-1600-2a01e298c908.webp 1600w",
          "sources": [
            {
              "src": "/products/product-016/image-02-480-0719acd902c8.webp",
              "width": 480,
              "height": 360
            },
            {
              "src": "/products/product-016/image-02-960-3ec1ead74b45.webp",
              "width": 960,
              "height": 720
            },
            {
              "src": "/products/product-016/image-02-1600-2a01e298c908.webp",
              "width": 1600,
              "height": 1200
            }
          ]
        }
      ]
    },
    {
      "id": "product-017",
      "name": "银摇钱树",
      "categoryId": "money-trees",
      "sourceDirectory": "银摇钱树",
      "images": [
        {
          "label": "正面",
          "alt": "银摇钱树，正面实拍图",
          "width": 1600,
          "height": 2133,
          "src": "/products/product-017/image-01-960-c05eeb895333.webp",
          "srcSet": "/products/product-017/image-01-480-f0f912ed7f22.webp 480w, /products/product-017/image-01-960-c05eeb895333.webp 960w, /products/product-017/image-01-1600-5569de96e6f8.webp 1600w",
          "sources": [
            {
              "src": "/products/product-017/image-01-480-f0f912ed7f22.webp",
              "width": 480,
              "height": 640
            },
            {
              "src": "/products/product-017/image-01-960-c05eeb895333.webp",
              "width": 960,
              "height": 1280
            },
            {
              "src": "/products/product-017/image-01-1600-5569de96e6f8.webp",
              "width": 1600,
              "height": 2133
            }
          ]
        },
        {
          "label": "侧面",
          "alt": "银摇钱树，侧面实拍图",
          "width": 1600,
          "height": 2133,
          "src": "/products/product-017/image-02-960-c7ce796ade6f.webp",
          "srcSet": "/products/product-017/image-02-480-3447b0c83e41.webp 480w, /products/product-017/image-02-960-c7ce796ade6f.webp 960w, /products/product-017/image-02-1600-f2862d6e5b06.webp 1600w",
          "sources": [
            {
              "src": "/products/product-017/image-02-480-3447b0c83e41.webp",
              "width": 480,
              "height": 640
            },
            {
              "src": "/products/product-017/image-02-960-c7ce796ade6f.webp",
              "width": 960,
              "height": 1280
            },
            {
              "src": "/products/product-017/image-02-1600-f2862d6e5b06.webp",
              "width": 1600,
              "height": 2133
            }
          ]
        }
      ]
    },
    {
      "id": "product-018",
      "name": "元宝树",
      "categoryId": "money-trees",
      "sourceDirectory": "元宝树",
      "images": [
        {
          "label": "正面",
          "alt": "元宝树，正面实拍图",
          "width": 1600,
          "height": 2133,
          "src": "/products/product-018/image-01-960-5e7b84dac86a.webp",
          "srcSet": "/products/product-018/image-01-480-8b713204944e.webp 480w, /products/product-018/image-01-960-5e7b84dac86a.webp 960w, /products/product-018/image-01-1600-d41351e0e2d2.webp 1600w",
          "sources": [
            {
              "src": "/products/product-018/image-01-480-8b713204944e.webp",
              "width": 480,
              "height": 640
            },
            {
              "src": "/products/product-018/image-01-960-5e7b84dac86a.webp",
              "width": 960,
              "height": 1280
            },
            {
              "src": "/products/product-018/image-01-1600-d41351e0e2d2.webp",
              "width": 1600,
              "height": 2133
            }
          ]
        },
        {
          "label": "侧面",
          "alt": "元宝树，侧面实拍图",
          "width": 1600,
          "height": 2133,
          "src": "/products/product-018/image-02-960-2c882a5c469d.webp",
          "srcSet": "/products/product-018/image-02-480-27c3317db28c.webp 480w, /products/product-018/image-02-960-2c882a5c469d.webp 960w, /products/product-018/image-02-1600-1851bdc18664.webp 1600w",
          "sources": [
            {
              "src": "/products/product-018/image-02-480-27c3317db28c.webp",
              "width": 480,
              "height": 640
            },
            {
              "src": "/products/product-018/image-02-960-2c882a5c469d.webp",
              "width": 960,
              "height": 1280
            },
            {
              "src": "/products/product-018/image-02-1600-1851bdc18664.webp",
              "width": 1600,
              "height": 2133
            }
          ]
        }
      ]
    },
    {
      "id": "product-019",
      "name": "中等摇钱树",
      "categoryId": "money-trees",
      "sourceDirectory": "中等摇钱树",
      "images": [
        {
          "label": "正面",
          "alt": "中等摇钱树，正面实拍图",
          "width": 1600,
          "height": 1200,
          "src": "/products/product-019/image-01-960-ddd43515044e.webp",
          "srcSet": "/products/product-019/image-01-480-fb957f2e62f5.webp 480w, /products/product-019/image-01-960-ddd43515044e.webp 960w, /products/product-019/image-01-1600-845d4e078485.webp 1600w",
          "sources": [
            {
              "src": "/products/product-019/image-01-480-fb957f2e62f5.webp",
              "width": 480,
              "height": 360
            },
            {
              "src": "/products/product-019/image-01-960-ddd43515044e.webp",
              "width": 960,
              "height": 720
            },
            {
              "src": "/products/product-019/image-01-1600-845d4e078485.webp",
              "width": 1600,
              "height": 1200
            }
          ]
        },
        {
          "label": "侧面",
          "alt": "中等摇钱树，侧面实拍图",
          "width": 1600,
          "height": 2133,
          "src": "/products/product-019/image-02-960-4875ed5f1b2d.webp",
          "srcSet": "/products/product-019/image-02-480-fee44baeb772.webp 480w, /products/product-019/image-02-960-4875ed5f1b2d.webp 960w, /products/product-019/image-02-1600-3266b4e0298d.webp 1600w",
          "sources": [
            {
              "src": "/products/product-019/image-02-480-fee44baeb772.webp",
              "width": 480,
              "height": 640
            },
            {
              "src": "/products/product-019/image-02-960-4875ed5f1b2d.webp",
              "width": 960,
              "height": 1280
            },
            {
              "src": "/products/product-019/image-02-1600-3266b4e0298d.webp",
              "width": 1600,
              "height": 2133
            }
          ]
        }
      ]
    },
    {
      "id": "product-020",
      "name": "金银聚宝盆",
      "categoryId": "money-trees",
      "sourceDirectory": "金银聚宝盆",
      "images": [
        {
          "label": "正面",
          "alt": "金银聚宝盆，正面实拍图",
          "width": 1600,
          "height": 1200,
          "src": "/products/product-020/image-01-960-d431889b616d.webp",
          "srcSet": "/products/product-020/image-01-480-ebeae96d2a91.webp 480w, /products/product-020/image-01-960-d431889b616d.webp 960w, /products/product-020/image-01-1600-828aabaeaae9.webp 1600w",
          "sources": [
            {
              "src": "/products/product-020/image-01-480-ebeae96d2a91.webp",
              "width": 480,
              "height": 360
            },
            {
              "src": "/products/product-020/image-01-960-d431889b616d.webp",
              "width": 960,
              "height": 720
            },
            {
              "src": "/products/product-020/image-01-1600-828aabaeaae9.webp",
              "width": 1600,
              "height": 1200
            }
          ]
        },
        {
          "label": "侧面",
          "alt": "金银聚宝盆，侧面实拍图",
          "width": 1600,
          "height": 1200,
          "src": "/products/product-020/image-02-960-408195ffb845.webp",
          "srcSet": "/products/product-020/image-02-480-4b8b0c5a354d.webp 480w, /products/product-020/image-02-960-408195ffb845.webp 960w, /products/product-020/image-02-1600-2807980ef30d.webp 1600w",
          "sources": [
            {
              "src": "/products/product-020/image-02-480-4b8b0c5a354d.webp",
              "width": 480,
              "height": 360
            },
            {
              "src": "/products/product-020/image-02-960-408195ffb845.webp",
              "width": 960,
              "height": 720
            },
            {
              "src": "/products/product-020/image-02-1600-2807980ef30d.webp",
              "width": 1600,
              "height": 1200
            }
          ]
        }
      ]
    },
    {
      "id": "product-021",
      "name": "八方来财",
      "categoryId": "wealth",
      "sourceDirectory": "八方来财",
      "images": [
        {
          "label": "正面",
          "alt": "八方来财，正面实拍图",
          "width": 1600,
          "height": 1200,
          "src": "/products/product-021/image-01-960-3bddfcaa491c.webp",
          "srcSet": "/products/product-021/image-01-480-306e2094d1e1.webp 480w, /products/product-021/image-01-960-3bddfcaa491c.webp 960w, /products/product-021/image-01-1600-32e15a61390a.webp 1600w",
          "sources": [
            {
              "src": "/products/product-021/image-01-480-306e2094d1e1.webp",
              "width": 480,
              "height": 360
            },
            {
              "src": "/products/product-021/image-01-960-3bddfcaa491c.webp",
              "width": 960,
              "height": 720
            },
            {
              "src": "/products/product-021/image-01-1600-32e15a61390a.webp",
              "width": 1600,
              "height": 1200
            }
          ]
        },
        {
          "label": "侧面",
          "alt": "八方来财，侧面实拍图",
          "width": 1600,
          "height": 1200,
          "src": "/products/product-021/image-02-960-9fd529d7684e.webp",
          "srcSet": "/products/product-021/image-02-480-0f106142dd1f.webp 480w, /products/product-021/image-02-960-9fd529d7684e.webp 960w, /products/product-021/image-02-1600-343f5a7fcd9e.webp 1600w",
          "sources": [
            {
              "src": "/products/product-021/image-02-480-0f106142dd1f.webp",
              "width": 480,
              "height": 360
            },
            {
              "src": "/products/product-021/image-02-960-9fd529d7684e.webp",
              "width": 960,
              "height": 720
            },
            {
              "src": "/products/product-021/image-02-1600-343f5a7fcd9e.webp",
              "width": 1600,
              "height": 1200
            }
          ]
        }
      ]
    },
    {
      "id": "product-022",
      "name": "百宝箱",
      "categoryId": "wealth",
      "sourceDirectory": "百宝箱",
      "images": [
        {
          "label": "正面",
          "alt": "百宝箱，正面实拍图",
          "width": 1600,
          "height": 1200,
          "src": "/products/product-022/image-01-960-7fff7a894038.webp",
          "srcSet": "/products/product-022/image-01-480-49de0d4df153.webp 480w, /products/product-022/image-01-960-7fff7a894038.webp 960w, /products/product-022/image-01-1600-a7df751269ab.webp 1600w",
          "sources": [
            {
              "src": "/products/product-022/image-01-480-49de0d4df153.webp",
              "width": 480,
              "height": 360
            },
            {
              "src": "/products/product-022/image-01-960-7fff7a894038.webp",
              "width": 960,
              "height": 720
            },
            {
              "src": "/products/product-022/image-01-1600-a7df751269ab.webp",
              "width": 1600,
              "height": 1200
            }
          ]
        },
        {
          "label": "侧面",
          "alt": "百宝箱，侧面实拍图",
          "width": 1600,
          "height": 1200,
          "src": "/products/product-022/image-02-960-4c0101ed0d36.webp",
          "srcSet": "/products/product-022/image-02-480-e8ab5dd59bf0.webp 480w, /products/product-022/image-02-960-4c0101ed0d36.webp 960w, /products/product-022/image-02-1600-83022cc4be5d.webp 1600w",
          "sources": [
            {
              "src": "/products/product-022/image-02-480-e8ab5dd59bf0.webp",
              "width": 480,
              "height": 360
            },
            {
              "src": "/products/product-022/image-02-960-4c0101ed0d36.webp",
              "width": 960,
              "height": 720
            },
            {
              "src": "/products/product-022/image-02-1600-83022cc4be5d.webp",
              "width": 1600,
              "height": 1200
            }
          ]
        }
      ]
    },
    {
      "id": "product-023",
      "name": "财源滚滚",
      "categoryId": "wealth",
      "sourceDirectory": "财源滚滚",
      "images": [
        {
          "label": "正面",
          "alt": "财源滚滚，正面实拍图",
          "width": 1600,
          "height": 2133,
          "src": "/products/product-023/image-01-960-1d66aac2f3e0.webp",
          "srcSet": "/products/product-023/image-01-480-1dd2472ae7b1.webp 480w, /products/product-023/image-01-960-1d66aac2f3e0.webp 960w, /products/product-023/image-01-1600-a2a3296c4069.webp 1600w",
          "sources": [
            {
              "src": "/products/product-023/image-01-480-1dd2472ae7b1.webp",
              "width": 480,
              "height": 640
            },
            {
              "src": "/products/product-023/image-01-960-1d66aac2f3e0.webp",
              "width": 960,
              "height": 1280
            },
            {
              "src": "/products/product-023/image-01-1600-a2a3296c4069.webp",
              "width": 1600,
              "height": 2133
            }
          ]
        },
        {
          "label": "侧面",
          "alt": "财源滚滚，侧面实拍图",
          "width": 1600,
          "height": 1200,
          "src": "/products/product-023/image-02-960-e20cb106c6f6.webp",
          "srcSet": "/products/product-023/image-02-480-8ac1a0062362.webp 480w, /products/product-023/image-02-960-e20cb106c6f6.webp 960w, /products/product-023/image-02-1600-0b9fec074c7a.webp 1600w",
          "sources": [
            {
              "src": "/products/product-023/image-02-480-8ac1a0062362.webp",
              "width": 480,
              "height": 360
            },
            {
              "src": "/products/product-023/image-02-960-e20cb106c6f6.webp",
              "width": 960,
              "height": 720
            },
            {
              "src": "/products/product-023/image-02-1600-0b9fec074c7a.webp",
              "width": 1600,
              "height": 1200
            }
          ]
        }
      ]
    },
    {
      "id": "product-024",
      "name": "豪华版步步高升",
      "categoryId": "wealth",
      "sourceDirectory": "豪华版步步高升",
      "images": [
        {
          "label": "正面",
          "alt": "豪华版步步高升，正面实拍图",
          "width": 1600,
          "height": 1200,
          "src": "/products/product-024/image-01-960-0c5fa34aee24.webp",
          "srcSet": "/products/product-024/image-01-480-6219a5f57fbb.webp 480w, /products/product-024/image-01-960-0c5fa34aee24.webp 960w, /products/product-024/image-01-1600-d8dff365cae5.webp 1600w",
          "sources": [
            {
              "src": "/products/product-024/image-01-480-6219a5f57fbb.webp",
              "width": 480,
              "height": 360
            },
            {
              "src": "/products/product-024/image-01-960-0c5fa34aee24.webp",
              "width": 960,
              "height": 720
            },
            {
              "src": "/products/product-024/image-01-1600-d8dff365cae5.webp",
              "width": 1600,
              "height": 1200
            }
          ]
        },
        {
          "label": "侧面",
          "alt": "豪华版步步高升，侧面实拍图",
          "width": 1600,
          "height": 2133,
          "src": "/products/product-024/image-02-960-db6216a4d457.webp",
          "srcSet": "/products/product-024/image-02-480-4125bc9577f8.webp 480w, /products/product-024/image-02-960-db6216a4d457.webp 960w, /products/product-024/image-02-1600-7a87f0867d65.webp 1600w",
          "sources": [
            {
              "src": "/products/product-024/image-02-480-4125bc9577f8.webp",
              "width": 480,
              "height": 640
            },
            {
              "src": "/products/product-024/image-02-960-db6216a4d457.webp",
              "width": 960,
              "height": 1280
            },
            {
              "src": "/products/product-024/image-02-1600-7a87f0867d65.webp",
              "width": 1600,
              "height": 2133
            }
          ]
        }
      ]
    },
    {
      "id": "product-025",
      "name": "豪华版金山",
      "categoryId": "wealth",
      "sourceDirectory": "豪华版金山",
      "images": [
        {
          "label": "正面",
          "alt": "豪华版金山，正面实拍图",
          "width": 1600,
          "height": 2133,
          "src": "/products/product-025/image-01-960-f6d3efec338f.webp",
          "srcSet": "/products/product-025/image-01-480-81183b0f2c77.webp 480w, /products/product-025/image-01-960-f6d3efec338f.webp 960w, /products/product-025/image-01-1600-9eea72135602.webp 1600w",
          "sources": [
            {
              "src": "/products/product-025/image-01-480-81183b0f2c77.webp",
              "width": 480,
              "height": 640
            },
            {
              "src": "/products/product-025/image-01-960-f6d3efec338f.webp",
              "width": 960,
              "height": 1280
            },
            {
              "src": "/products/product-025/image-01-1600-9eea72135602.webp",
              "width": 1600,
              "height": 2133
            }
          ]
        },
        {
          "label": "侧面",
          "alt": "豪华版金山，侧面实拍图",
          "width": 1600,
          "height": 2133,
          "src": "/products/product-025/image-02-960-39abb321269a.webp",
          "srcSet": "/products/product-025/image-02-480-802ea472808c.webp 480w, /products/product-025/image-02-960-39abb321269a.webp 960w, /products/product-025/image-02-1600-a66bf97c004f.webp 1600w",
          "sources": [
            {
              "src": "/products/product-025/image-02-480-802ea472808c.webp",
              "width": 480,
              "height": 640
            },
            {
              "src": "/products/product-025/image-02-960-39abb321269a.webp",
              "width": 960,
              "height": 1280
            },
            {
              "src": "/products/product-025/image-02-1600-a66bf97c004f.webp",
              "width": 1600,
              "height": 2133
            }
          ]
        }
      ]
    },
    {
      "id": "product-026",
      "name": "豪华金山银山",
      "categoryId": "wealth",
      "sourceDirectory": "豪华金山银山",
      "images": [
        {
          "label": "正面",
          "alt": "豪华金山银山，正面实拍图",
          "width": 1600,
          "height": 1200,
          "src": "/products/product-026/image-01-960-e51e61413c31.webp",
          "srcSet": "/products/product-026/image-01-480-f9e2c13a6a05.webp 480w, /products/product-026/image-01-960-e51e61413c31.webp 960w, /products/product-026/image-01-1600-e5b7c77bddd4.webp 1600w",
          "sources": [
            {
              "src": "/products/product-026/image-01-480-f9e2c13a6a05.webp",
              "width": 480,
              "height": 360
            },
            {
              "src": "/products/product-026/image-01-960-e51e61413c31.webp",
              "width": 960,
              "height": 720
            },
            {
              "src": "/products/product-026/image-01-1600-e5b7c77bddd4.webp",
              "width": 1600,
              "height": 1200
            }
          ]
        },
        {
          "label": "侧面",
          "alt": "豪华金山银山，侧面实拍图",
          "width": 1600,
          "height": 1200,
          "src": "/products/product-026/image-02-960-e61cd12ca900.webp",
          "srcSet": "/products/product-026/image-02-480-5e789cbec202.webp 480w, /products/product-026/image-02-960-e61cd12ca900.webp 960w, /products/product-026/image-02-1600-0c1ae0eec622.webp 1600w",
          "sources": [
            {
              "src": "/products/product-026/image-02-480-5e789cbec202.webp",
              "width": 480,
              "height": 360
            },
            {
              "src": "/products/product-026/image-02-960-e61cd12ca900.webp",
              "width": 960,
              "height": 720
            },
            {
              "src": "/products/product-026/image-02-1600-0c1ae0eec622.webp",
              "width": 1600,
              "height": 1200
            }
          ]
        }
      ]
    },
    {
      "id": "product-027",
      "name": "豪华款钱山",
      "categoryId": "wealth",
      "sourceDirectory": "豪华款钱山",
      "images": [
        {
          "label": "正面",
          "alt": "豪华款钱山，正面实拍图",
          "width": 1600,
          "height": 2133,
          "src": "/products/product-027/image-01-960-b8f63bea1c8a.webp",
          "srcSet": "/products/product-027/image-01-480-e57ad8e25a02.webp 480w, /products/product-027/image-01-960-b8f63bea1c8a.webp 960w, /products/product-027/image-01-1600-4403178b07dd.webp 1600w",
          "sources": [
            {
              "src": "/products/product-027/image-01-480-e57ad8e25a02.webp",
              "width": 480,
              "height": 640
            },
            {
              "src": "/products/product-027/image-01-960-b8f63bea1c8a.webp",
              "width": 960,
              "height": 1280
            },
            {
              "src": "/products/product-027/image-01-1600-4403178b07dd.webp",
              "width": 1600,
              "height": 2133
            }
          ]
        },
        {
          "label": "侧面",
          "alt": "豪华款钱山，侧面实拍图",
          "width": 1600,
          "height": 2133,
          "src": "/products/product-027/image-02-960-d4d9eac99827.webp",
          "srcSet": "/products/product-027/image-02-480-b5da3e58a4c8.webp 480w, /products/product-027/image-02-960-d4d9eac99827.webp 960w, /products/product-027/image-02-1600-97b5680dfa84.webp 1600w",
          "sources": [
            {
              "src": "/products/product-027/image-02-480-b5da3e58a4c8.webp",
              "width": 480,
              "height": 640
            },
            {
              "src": "/products/product-027/image-02-960-d4d9eac99827.webp",
              "width": 960,
              "height": 1280
            },
            {
              "src": "/products/product-027/image-02-1600-97b5680dfa84.webp",
              "width": 1600,
              "height": 2133
            }
          ]
        }
      ]
    },
    {
      "id": "product-028",
      "name": "豪华三层金山银山",
      "categoryId": "wealth",
      "sourceDirectory": "豪华三层金山银山",
      "images": [
        {
          "label": "正面",
          "alt": "豪华三层金山银山，正面实拍图",
          "width": 1600,
          "height": 1200,
          "src": "/products/product-028/image-01-960-6f0587a3e61e.webp",
          "srcSet": "/products/product-028/image-01-480-d6e4f86a07bc.webp 480w, /products/product-028/image-01-960-6f0587a3e61e.webp 960w, /products/product-028/image-01-1600-f5c9493b0b17.webp 1600w",
          "sources": [
            {
              "src": "/products/product-028/image-01-480-d6e4f86a07bc.webp",
              "width": 480,
              "height": 360
            },
            {
              "src": "/products/product-028/image-01-960-6f0587a3e61e.webp",
              "width": 960,
              "height": 720
            },
            {
              "src": "/products/product-028/image-01-1600-f5c9493b0b17.webp",
              "width": 1600,
              "height": 1200
            }
          ]
        },
        {
          "label": "侧面",
          "alt": "豪华三层金山银山，侧面实拍图",
          "width": 1600,
          "height": 1200,
          "src": "/products/product-028/image-02-960-ab076a3f6f2f.webp",
          "srcSet": "/products/product-028/image-02-480-eee5b1172db0.webp 480w, /products/product-028/image-02-960-ab076a3f6f2f.webp 960w, /products/product-028/image-02-1600-f0e07ecb2d23.webp 1600w",
          "sources": [
            {
              "src": "/products/product-028/image-02-480-eee5b1172db0.webp",
              "width": 480,
              "height": 360
            },
            {
              "src": "/products/product-028/image-02-960-ab076a3f6f2f.webp",
              "width": 960,
              "height": 720
            },
            {
              "src": "/products/product-028/image-02-1600-f0e07ecb2d23.webp",
              "width": 1600,
              "height": 1200
            }
          ]
        }
      ]
    },
    {
      "id": "product-029",
      "name": "金库银库",
      "categoryId": "wealth",
      "sourceDirectory": "金库银库",
      "images": [
        {
          "label": "正面",
          "alt": "金库银库，正面实拍图",
          "width": 1600,
          "height": 1200,
          "src": "/products/product-029/image-01-960-d0ee3bbede57.webp",
          "srcSet": "/products/product-029/image-01-480-0c8af2550eda.webp 480w, /products/product-029/image-01-960-d0ee3bbede57.webp 960w, /products/product-029/image-01-1600-63c4939b46f4.webp 1600w",
          "sources": [
            {
              "src": "/products/product-029/image-01-480-0c8af2550eda.webp",
              "width": 480,
              "height": 360
            },
            {
              "src": "/products/product-029/image-01-960-d0ee3bbede57.webp",
              "width": 960,
              "height": 720
            },
            {
              "src": "/products/product-029/image-01-1600-63c4939b46f4.webp",
              "width": 1600,
              "height": 1200
            }
          ]
        },
        {
          "label": "侧面",
          "alt": "金库银库，侧面实拍图",
          "width": 1600,
          "height": 1200,
          "src": "/products/product-029/image-02-960-b8a37c1037e9.webp",
          "srcSet": "/products/product-029/image-02-480-b207765076d8.webp 480w, /products/product-029/image-02-960-b8a37c1037e9.webp 960w, /products/product-029/image-02-1600-5191db804bd1.webp 1600w",
          "sources": [
            {
              "src": "/products/product-029/image-02-480-b207765076d8.webp",
              "width": 480,
              "height": 360
            },
            {
              "src": "/products/product-029/image-02-960-b8a37c1037e9.webp",
              "width": 960,
              "height": 720
            },
            {
              "src": "/products/product-029/image-02-1600-5191db804bd1.webp",
              "width": 1600,
              "height": 1200
            }
          ]
        }
      ]
    },
    {
      "id": "product-030",
      "name": "金桥银桥",
      "categoryId": "wealth",
      "sourceDirectory": "金桥银桥",
      "images": [
        {
          "label": "正面",
          "alt": "金桥银桥，正面实拍图",
          "width": 1600,
          "height": 1200,
          "src": "/products/product-030/image-01-960-088f21a645d6.webp",
          "srcSet": "/products/product-030/image-01-480-ddc938ea5955.webp 480w, /products/product-030/image-01-960-088f21a645d6.webp 960w, /products/product-030/image-01-1600-d2f704e78ff2.webp 1600w",
          "sources": [
            {
              "src": "/products/product-030/image-01-480-ddc938ea5955.webp",
              "width": 480,
              "height": 360
            },
            {
              "src": "/products/product-030/image-01-960-088f21a645d6.webp",
              "width": 960,
              "height": 720
            },
            {
              "src": "/products/product-030/image-01-1600-d2f704e78ff2.webp",
              "width": 1600,
              "height": 1200
            }
          ]
        },
        {
          "label": "侧面",
          "alt": "金桥银桥，侧面实拍图",
          "width": 1600,
          "height": 1200,
          "src": "/products/product-030/image-02-960-99ce16f31818.webp",
          "srcSet": "/products/product-030/image-02-480-c4383b427420.webp 480w, /products/product-030/image-02-960-99ce16f31818.webp 960w, /products/product-030/image-02-1600-8d81d48379ab.webp 1600w",
          "sources": [
            {
              "src": "/products/product-030/image-02-480-c4383b427420.webp",
              "width": 480,
              "height": 360
            },
            {
              "src": "/products/product-030/image-02-960-99ce16f31818.webp",
              "width": 960,
              "height": 720
            },
            {
              "src": "/products/product-030/image-02-1600-8d81d48379ab.webp",
              "width": 1600,
              "height": 1200
            }
          ]
        }
      ]
    },
    {
      "id": "product-031",
      "name": "金桶",
      "categoryId": "wealth",
      "sourceDirectory": "金桶",
      "images": [
        {
          "label": "正面",
          "alt": "金桶，正面实拍图",
          "width": 1600,
          "height": 1200,
          "src": "/products/product-031/image-01-960-63ab9d368c99.webp",
          "srcSet": "/products/product-031/image-01-480-7a8cda8a96a5.webp 480w, /products/product-031/image-01-960-63ab9d368c99.webp 960w, /products/product-031/image-01-1600-4d1ea4e1ddfb.webp 1600w",
          "sources": [
            {
              "src": "/products/product-031/image-01-480-7a8cda8a96a5.webp",
              "width": 480,
              "height": 360
            },
            {
              "src": "/products/product-031/image-01-960-63ab9d368c99.webp",
              "width": 960,
              "height": 720
            },
            {
              "src": "/products/product-031/image-01-1600-4d1ea4e1ddfb.webp",
              "width": 1600,
              "height": 1200
            }
          ]
        },
        {
          "label": "侧面",
          "alt": "金桶，侧面实拍图",
          "width": 1600,
          "height": 1200,
          "src": "/products/product-031/image-02-960-b322367421dc.webp",
          "srcSet": "/products/product-031/image-02-480-8ff5599cce4c.webp 480w, /products/product-031/image-02-960-b322367421dc.webp 960w, /products/product-031/image-02-1600-f974d1d6df7e.webp 1600w",
          "sources": [
            {
              "src": "/products/product-031/image-02-480-8ff5599cce4c.webp",
              "width": 480,
              "height": 360
            },
            {
              "src": "/products/product-031/image-02-960-b322367421dc.webp",
              "width": 960,
              "height": 720
            },
            {
              "src": "/products/product-031/image-02-1600-f974d1d6df7e.webp",
              "width": 1600,
              "height": 1200
            }
          ]
        }
      ]
    },
    {
      "id": "product-032",
      "name": "金银步步高升",
      "categoryId": "wealth",
      "sourceDirectory": "金银步步高升",
      "images": [
        {
          "label": "正面",
          "alt": "金银步步高升，正面实拍图",
          "width": 1600,
          "height": 1200,
          "src": "/products/product-032/image-01-960-221dda6b7825.webp",
          "srcSet": "/products/product-032/image-01-480-169ede37f787.webp 480w, /products/product-032/image-01-960-221dda6b7825.webp 960w, /products/product-032/image-01-1600-2d35df087dee.webp 1600w",
          "sources": [
            {
              "src": "/products/product-032/image-01-480-169ede37f787.webp",
              "width": 480,
              "height": 360
            },
            {
              "src": "/products/product-032/image-01-960-221dda6b7825.webp",
              "width": 960,
              "height": 720
            },
            {
              "src": "/products/product-032/image-01-1600-2d35df087dee.webp",
              "width": 1600,
              "height": 1200
            }
          ]
        },
        {
          "label": "侧面",
          "alt": "金银步步高升，侧面实拍图",
          "width": 1600,
          "height": 1200,
          "src": "/products/product-032/image-02-960-bcfa68e78991.webp",
          "srcSet": "/products/product-032/image-02-480-477f63e14e2d.webp 480w, /products/product-032/image-02-960-bcfa68e78991.webp 960w, /products/product-032/image-02-1600-7f0678e7d1bd.webp 1600w",
          "sources": [
            {
              "src": "/products/product-032/image-02-480-477f63e14e2d.webp",
              "width": 480,
              "height": 360
            },
            {
              "src": "/products/product-032/image-02-960-bcfa68e78991.webp",
              "width": 960,
              "height": 720
            },
            {
              "src": "/products/product-032/image-02-1600-7f0678e7d1bd.webp",
              "width": 1600,
              "height": 1200
            }
          ]
        }
      ]
    },
    {
      "id": "product-033",
      "name": "金银元宝",
      "categoryId": "wealth",
      "sourceDirectory": "金银元宝",
      "images": [
        {
          "label": "正面",
          "alt": "金银元宝，正面实拍图",
          "width": 1600,
          "height": 2133,
          "src": "/products/product-033/image-01-960-d358eb936529.webp",
          "srcSet": "/products/product-033/image-01-480-d9cdb94c7f19.webp 480w, /products/product-033/image-01-960-d358eb936529.webp 960w, /products/product-033/image-01-1600-057c50a938fa.webp 1600w",
          "sources": [
            {
              "src": "/products/product-033/image-01-480-d9cdb94c7f19.webp",
              "width": 480,
              "height": 640
            },
            {
              "src": "/products/product-033/image-01-960-d358eb936529.webp",
              "width": 960,
              "height": 1280
            },
            {
              "src": "/products/product-033/image-01-1600-057c50a938fa.webp",
              "width": 1600,
              "height": 2133
            }
          ]
        },
        {
          "label": "侧面",
          "alt": "金银元宝，侧面实拍图",
          "width": 1600,
          "height": 1200,
          "src": "/products/product-033/image-02-960-711dfb21e577.webp",
          "srcSet": "/products/product-033/image-02-480-72ed6105a666.webp 480w, /products/product-033/image-02-960-711dfb21e577.webp 960w, /products/product-033/image-02-1600-f8e07b35ece5.webp 1600w",
          "sources": [
            {
              "src": "/products/product-033/image-02-480-72ed6105a666.webp",
              "width": 480,
              "height": 360
            },
            {
              "src": "/products/product-033/image-02-960-711dfb21e577.webp",
              "width": 960,
              "height": 720
            },
            {
              "src": "/products/product-033/image-02-1600-f8e07b35ece5.webp",
              "width": 1600,
              "height": 1200
            }
          ]
        }
      ]
    },
    {
      "id": "product-034",
      "name": "粮满仓",
      "categoryId": "wealth",
      "sourceDirectory": "粮满仓",
      "images": [
        {
          "label": "正面",
          "alt": "粮满仓，正面实拍图",
          "width": 1600,
          "height": 2133,
          "src": "/products/product-034/image-01-960-c874cbd444dd.webp",
          "srcSet": "/products/product-034/image-01-480-78eebab4ecc6.webp 480w, /products/product-034/image-01-960-c874cbd444dd.webp 960w, /products/product-034/image-01-1600-beb58bda8014.webp 1600w",
          "sources": [
            {
              "src": "/products/product-034/image-01-480-78eebab4ecc6.webp",
              "width": 480,
              "height": 640
            },
            {
              "src": "/products/product-034/image-01-960-c874cbd444dd.webp",
              "width": 960,
              "height": 1280
            },
            {
              "src": "/products/product-034/image-01-1600-beb58bda8014.webp",
              "width": 1600,
              "height": 2133
            }
          ]
        },
        {
          "label": "侧面",
          "alt": "粮满仓，侧面实拍图",
          "width": 1600,
          "height": 2133,
          "src": "/products/product-034/image-02-960-5b5cf60ced8c.webp",
          "srcSet": "/products/product-034/image-02-480-430251988d30.webp 480w, /products/product-034/image-02-960-5b5cf60ced8c.webp 960w, /products/product-034/image-02-1600-e0574232516f.webp 1600w",
          "sources": [
            {
              "src": "/products/product-034/image-02-480-430251988d30.webp",
              "width": 480,
              "height": 640
            },
            {
              "src": "/products/product-034/image-02-960-5b5cf60ced8c.webp",
              "width": 960,
              "height": 1280
            },
            {
              "src": "/products/product-034/image-02-1600-e0574232516f.webp",
              "width": 1600,
              "height": 2133
            }
          ]
        }
      ]
    },
    {
      "id": "product-035",
      "name": "米山面山",
      "categoryId": "wealth",
      "sourceDirectory": "米山面山",
      "images": [
        {
          "label": "正面",
          "alt": "米山面山，正面实拍图",
          "width": 1600,
          "height": 2133,
          "src": "/products/product-035/image-01-960-43e175f9baee.webp",
          "srcSet": "/products/product-035/image-01-480-a930d5fd961d.webp 480w, /products/product-035/image-01-960-43e175f9baee.webp 960w, /products/product-035/image-01-1600-e35bd48fc024.webp 1600w",
          "sources": [
            {
              "src": "/products/product-035/image-01-480-a930d5fd961d.webp",
              "width": 480,
              "height": 640
            },
            {
              "src": "/products/product-035/image-01-960-43e175f9baee.webp",
              "width": 960,
              "height": 1280
            },
            {
              "src": "/products/product-035/image-01-1600-e35bd48fc024.webp",
              "width": 1600,
              "height": 2133
            }
          ]
        },
        {
          "label": "侧面",
          "alt": "米山面山，侧面实拍图",
          "width": 1600,
          "height": 2133,
          "src": "/products/product-035/image-02-960-27a5721f8e7c.webp",
          "srcSet": "/products/product-035/image-02-480-18f1212c3985.webp 480w, /products/product-035/image-02-960-27a5721f8e7c.webp 960w, /products/product-035/image-02-1600-46b28601a9a0.webp 1600w",
          "sources": [
            {
              "src": "/products/product-035/image-02-480-18f1212c3985.webp",
              "width": 480,
              "height": 640
            },
            {
              "src": "/products/product-035/image-02-960-27a5721f8e7c.webp",
              "width": 960,
              "height": 1280
            },
            {
              "src": "/products/product-035/image-02-1600-46b28601a9a0.webp",
              "width": 1600,
              "height": 2133
            }
          ]
        }
      ]
    },
    {
      "id": "product-036",
      "name": "钱满仓",
      "categoryId": "wealth",
      "sourceDirectory": "钱满仓",
      "images": [
        {
          "label": "正面",
          "alt": "钱满仓，正面实拍图",
          "width": 1600,
          "height": 2133,
          "src": "/products/product-036/image-01-960-0303ccf58e53.webp",
          "srcSet": "/products/product-036/image-01-480-88deabc1936c.webp 480w, /products/product-036/image-01-960-0303ccf58e53.webp 960w, /products/product-036/image-01-1600-dbb49219b8e5.webp 1600w",
          "sources": [
            {
              "src": "/products/product-036/image-01-480-88deabc1936c.webp",
              "width": 480,
              "height": 640
            },
            {
              "src": "/products/product-036/image-01-960-0303ccf58e53.webp",
              "width": 960,
              "height": 1280
            },
            {
              "src": "/products/product-036/image-01-1600-dbb49219b8e5.webp",
              "width": 1600,
              "height": 2133
            }
          ]
        },
        {
          "label": "侧面",
          "alt": "钱满仓，侧面实拍图",
          "width": 1600,
          "height": 2133,
          "src": "/products/product-036/image-02-960-63cd0d7c596e.webp",
          "srcSet": "/products/product-036/image-02-480-00d3cd474574.webp 480w, /products/product-036/image-02-960-63cd0d7c596e.webp 960w, /products/product-036/image-02-1600-96f384b651a6.webp 1600w",
          "sources": [
            {
              "src": "/products/product-036/image-02-480-00d3cd474574.webp",
              "width": 480,
              "height": 640
            },
            {
              "src": "/products/product-036/image-02-960-63cd0d7c596e.webp",
              "width": 960,
              "height": 1280
            },
            {
              "src": "/products/product-036/image-02-1600-96f384b651a6.webp",
              "width": 1600,
              "height": 2133
            }
          ]
        }
      ]
    },
    {
      "id": "product-037",
      "name": "钱山",
      "categoryId": "wealth",
      "sourceDirectory": "钱山",
      "images": [
        {
          "label": "正面",
          "alt": "钱山，正面实拍图",
          "width": 1600,
          "height": 1200,
          "src": "/products/product-037/image-01-960-71cfe40a2cce.webp",
          "srcSet": "/products/product-037/image-01-480-8366e8652d10.webp 480w, /products/product-037/image-01-960-71cfe40a2cce.webp 960w, /products/product-037/image-01-1600-4904af72514d.webp 1600w",
          "sources": [
            {
              "src": "/products/product-037/image-01-480-8366e8652d10.webp",
              "width": 480,
              "height": 360
            },
            {
              "src": "/products/product-037/image-01-960-71cfe40a2cce.webp",
              "width": 960,
              "height": 720
            },
            {
              "src": "/products/product-037/image-01-1600-4904af72514d.webp",
              "width": 1600,
              "height": 1200
            }
          ]
        },
        {
          "label": "侧面",
          "alt": "钱山，侧面实拍图",
          "width": 1600,
          "height": 1200,
          "src": "/products/product-037/image-02-960-ac9673ca61e4.webp",
          "srcSet": "/products/product-037/image-02-480-e6c216c8c409.webp 480w, /products/product-037/image-02-960-ac9673ca61e4.webp 960w, /products/product-037/image-02-1600-f4471c37e69d.webp 1600w",
          "sources": [
            {
              "src": "/products/product-037/image-02-480-e6c216c8c409.webp",
              "width": 480,
              "height": 360
            },
            {
              "src": "/products/product-037/image-02-960-ac9673ca61e4.webp",
              "width": 960,
              "height": 720
            },
            {
              "src": "/products/product-037/image-02-1600-f4471c37e69d.webp",
              "width": 1600,
              "height": 1200
            }
          ]
        }
      ]
    },
    {
      "id": "product-038",
      "name": "五福金山",
      "categoryId": "wealth",
      "sourceDirectory": "五福金山",
      "images": [
        {
          "label": "正面",
          "alt": "五福金山，正面实拍图",
          "width": 1600,
          "height": 2133,
          "src": "/products/product-038/image-01-960-416da6e3190a.webp",
          "srcSet": "/products/product-038/image-01-480-831dadec57f6.webp 480w, /products/product-038/image-01-960-416da6e3190a.webp 960w, /products/product-038/image-01-1600-27d0f0e48214.webp 1600w",
          "sources": [
            {
              "src": "/products/product-038/image-01-480-831dadec57f6.webp",
              "width": 480,
              "height": 640
            },
            {
              "src": "/products/product-038/image-01-960-416da6e3190a.webp",
              "width": 960,
              "height": 1280
            },
            {
              "src": "/products/product-038/image-01-1600-27d0f0e48214.webp",
              "width": 1600,
              "height": 2133
            }
          ]
        },
        {
          "label": "侧面",
          "alt": "五福金山，侧面实拍图",
          "width": 1600,
          "height": 2133,
          "src": "/products/product-038/image-02-960-2ddcf956adb7.webp",
          "srcSet": "/products/product-038/image-02-480-a9cbbd902bda.webp 480w, /products/product-038/image-02-960-2ddcf956adb7.webp 960w, /products/product-038/image-02-1600-85b41b5b0a40.webp 1600w",
          "sources": [
            {
              "src": "/products/product-038/image-02-480-a9cbbd902bda.webp",
              "width": 480,
              "height": 640
            },
            {
              "src": "/products/product-038/image-02-960-2ddcf956adb7.webp",
              "width": 960,
              "height": 1280
            },
            {
              "src": "/products/product-038/image-02-1600-85b41b5b0a40.webp",
              "width": 1600,
              "height": 2133
            }
          ]
        }
      ]
    },
    {
      "id": "product-039",
      "name": "一担金",
      "categoryId": "wealth",
      "sourceDirectory": "一旦金",
      "images": [
        {
          "label": "正面",
          "alt": "一担金，正面实拍图",
          "width": 1600,
          "height": 1200,
          "src": "/products/product-039/image-01-960-4d61d815a24f.webp",
          "srcSet": "/products/product-039/image-01-480-2fc367f4cdcf.webp 480w, /products/product-039/image-01-960-4d61d815a24f.webp 960w, /products/product-039/image-01-1600-aeef1f05eaf3.webp 1600w",
          "sources": [
            {
              "src": "/products/product-039/image-01-480-2fc367f4cdcf.webp",
              "width": 480,
              "height": 360
            },
            {
              "src": "/products/product-039/image-01-960-4d61d815a24f.webp",
              "width": 960,
              "height": 720
            },
            {
              "src": "/products/product-039/image-01-1600-aeef1f05eaf3.webp",
              "width": 1600,
              "height": 1200
            }
          ]
        },
        {
          "label": "侧面",
          "alt": "一担金，侧面实拍图",
          "width": 1600,
          "height": 1200,
          "src": "/products/product-039/image-02-960-712e2ce01e7b.webp",
          "srcSet": "/products/product-039/image-02-480-bccf9336cade.webp 480w, /products/product-039/image-02-960-712e2ce01e7b.webp 960w, /products/product-039/image-02-1600-57d43225a0ea.webp 1600w",
          "sources": [
            {
              "src": "/products/product-039/image-02-480-bccf9336cade.webp",
              "width": 480,
              "height": 360
            },
            {
              "src": "/products/product-039/image-02-960-712e2ce01e7b.webp",
              "width": 960,
              "height": 720
            },
            {
              "src": "/products/product-039/image-02-1600-57d43225a0ea.webp",
              "width": 1600,
              "height": 1200
            }
          ]
        }
      ]
    },
    {
      "id": "product-040",
      "name": "一担金银",
      "categoryId": "wealth",
      "sourceDirectory": "一旦金银",
      "images": [
        {
          "label": "正面",
          "alt": "一担金银，正面实拍图",
          "width": 1600,
          "height": 1200,
          "src": "/products/product-040/image-01-960-bf4ef4605f57.webp",
          "srcSet": "/products/product-040/image-01-480-de96af194c5b.webp 480w, /products/product-040/image-01-960-bf4ef4605f57.webp 960w, /products/product-040/image-01-1600-eaa3e30ac79e.webp 1600w",
          "sources": [
            {
              "src": "/products/product-040/image-01-480-de96af194c5b.webp",
              "width": 480,
              "height": 360
            },
            {
              "src": "/products/product-040/image-01-960-bf4ef4605f57.webp",
              "width": 960,
              "height": 720
            },
            {
              "src": "/products/product-040/image-01-1600-eaa3e30ac79e.webp",
              "width": 1600,
              "height": 1200
            }
          ]
        },
        {
          "label": "侧面",
          "alt": "一担金银，侧面实拍图",
          "width": 1600,
          "height": 1200,
          "src": "/products/product-040/image-02-960-c119b3dbf445.webp",
          "srcSet": "/products/product-040/image-02-480-fe64bc5eed82.webp 480w, /products/product-040/image-02-960-c119b3dbf445.webp 960w, /products/product-040/image-02-1600-a16977bcaf1c.webp 1600w",
          "sources": [
            {
              "src": "/products/product-040/image-02-480-fe64bc5eed82.webp",
              "width": 480,
              "height": 360
            },
            {
              "src": "/products/product-040/image-02-960-c119b3dbf445.webp",
              "width": 960,
              "height": 720
            },
            {
              "src": "/products/product-040/image-02-1600-a16977bcaf1c.webp",
              "width": 1600,
              "height": 1200
            }
          ]
        }
      ]
    },
    {
      "id": "product-041",
      "name": "电动车",
      "categoryId": "transport",
      "sourceDirectory": "电动车",
      "images": [
        {
          "label": "正面",
          "alt": "电动车，正面实拍图",
          "width": 1600,
          "height": 1200,
          "src": "/products/product-041/image-01-960-443124d9a6d9.webp",
          "srcSet": "/products/product-041/image-01-480-28a47a6306cf.webp 480w, /products/product-041/image-01-960-443124d9a6d9.webp 960w, /products/product-041/image-01-1600-8ec846aaa86d.webp 1600w",
          "sources": [
            {
              "src": "/products/product-041/image-01-480-28a47a6306cf.webp",
              "width": 480,
              "height": 360
            },
            {
              "src": "/products/product-041/image-01-960-443124d9a6d9.webp",
              "width": 960,
              "height": 720
            },
            {
              "src": "/products/product-041/image-01-1600-8ec846aaa86d.webp",
              "width": 1600,
              "height": 1200
            }
          ]
        },
        {
          "label": "侧面",
          "alt": "电动车，侧面实拍图",
          "width": 1600,
          "height": 1200,
          "src": "/products/product-041/image-02-960-07dfdfe46e2f.webp",
          "srcSet": "/products/product-041/image-02-480-e80fa520fffd.webp 480w, /products/product-041/image-02-960-07dfdfe46e2f.webp 960w, /products/product-041/image-02-1600-faff6e4d1186.webp 1600w",
          "sources": [
            {
              "src": "/products/product-041/image-02-480-e80fa520fffd.webp",
              "width": 480,
              "height": 360
            },
            {
              "src": "/products/product-041/image-02-960-07dfdfe46e2f.webp",
              "width": 960,
              "height": 720
            },
            {
              "src": "/products/product-041/image-02-1600-faff6e4d1186.webp",
              "width": 1600,
              "height": 1200
            }
          ]
        }
      ]
    },
    {
      "id": "product-042",
      "name": "豪华电动三轮车",
      "categoryId": "transport",
      "sourceDirectory": "豪华电动三轮车",
      "images": [
        {
          "label": "正面",
          "alt": "豪华电动三轮车，正面实拍图",
          "width": 1600,
          "height": 2133,
          "src": "/products/product-042/image-01-960-549bb15b8ec1.webp",
          "srcSet": "/products/product-042/image-01-480-804b4576ff24.webp 480w, /products/product-042/image-01-960-549bb15b8ec1.webp 960w, /products/product-042/image-01-1600-312ca164fa14.webp 1600w",
          "sources": [
            {
              "src": "/products/product-042/image-01-480-804b4576ff24.webp",
              "width": 480,
              "height": 640
            },
            {
              "src": "/products/product-042/image-01-960-549bb15b8ec1.webp",
              "width": 960,
              "height": 1280
            },
            {
              "src": "/products/product-042/image-01-1600-312ca164fa14.webp",
              "width": 1600,
              "height": 2133
            }
          ]
        },
        {
          "label": "侧面",
          "alt": "豪华电动三轮车，侧面实拍图",
          "width": 1600,
          "height": 1200,
          "src": "/products/product-042/image-02-960-a744141cdef9.webp",
          "srcSet": "/products/product-042/image-02-480-b408914f1830.webp 480w, /products/product-042/image-02-960-a744141cdef9.webp 960w, /products/product-042/image-02-1600-faaf14ecdb8e.webp 1600w",
          "sources": [
            {
              "src": "/products/product-042/image-02-480-b408914f1830.webp",
              "width": 480,
              "height": 360
            },
            {
              "src": "/products/product-042/image-02-960-a744141cdef9.webp",
              "width": 960,
              "height": 720
            },
            {
              "src": "/products/product-042/image-02-1600-faaf14ecdb8e.webp",
              "width": 1600,
              "height": 1200
            }
          ]
        }
      ]
    },
    {
      "id": "product-043",
      "name": "普通款电动三轮车",
      "categoryId": "transport",
      "sourceDirectory": "普通款电动三轮车",
      "images": [
        {
          "label": "正面",
          "alt": "普通款电动三轮车，正面实拍图",
          "width": 1600,
          "height": 1200,
          "src": "/products/product-043/image-01-960-a930bf7c18b1.webp",
          "srcSet": "/products/product-043/image-01-480-0fa2018c85c1.webp 480w, /products/product-043/image-01-960-a930bf7c18b1.webp 960w, /products/product-043/image-01-1600-c75fa3a3b8ee.webp 1600w",
          "sources": [
            {
              "src": "/products/product-043/image-01-480-0fa2018c85c1.webp",
              "width": 480,
              "height": 360
            },
            {
              "src": "/products/product-043/image-01-960-a930bf7c18b1.webp",
              "width": 960,
              "height": 720
            },
            {
              "src": "/products/product-043/image-01-1600-c75fa3a3b8ee.webp",
              "width": 1600,
              "height": 1200
            }
          ]
        },
        {
          "label": "侧面",
          "alt": "普通款电动三轮车，侧面实拍图",
          "width": 1600,
          "height": 1200,
          "src": "/products/product-043/image-02-960-a70ae7ce0935.webp",
          "srcSet": "/products/product-043/image-02-480-387d81b9fbae.webp 480w, /products/product-043/image-02-960-a70ae7ce0935.webp 960w, /products/product-043/image-02-1600-18144f87f4c0.webp 1600w",
          "sources": [
            {
              "src": "/products/product-043/image-02-480-387d81b9fbae.webp",
              "width": 480,
              "height": 360
            },
            {
              "src": "/products/product-043/image-02-960-a70ae7ce0935.webp",
              "width": 960,
              "height": 720
            },
            {
              "src": "/products/product-043/image-02-1600-18144f87f4c0.webp",
              "width": 1600,
              "height": 1200
            }
          ]
        }
      ]
    },
    {
      "id": "product-044",
      "name": "保险柜",
      "categoryId": "home-life",
      "sourceDirectory": "保险柜",
      "images": [
        {
          "label": "正面",
          "alt": "保险柜，正面实拍图",
          "width": 1600,
          "height": 2133,
          "src": "/products/product-044/image-01-960-00a67b2501e6.webp",
          "srcSet": "/products/product-044/image-01-480-707d6a1a2b1b.webp 480w, /products/product-044/image-01-960-00a67b2501e6.webp 960w, /products/product-044/image-01-1600-9e355564c027.webp 1600w",
          "sources": [
            {
              "src": "/products/product-044/image-01-480-707d6a1a2b1b.webp",
              "width": 480,
              "height": 640
            },
            {
              "src": "/products/product-044/image-01-960-00a67b2501e6.webp",
              "width": 960,
              "height": 1280
            },
            {
              "src": "/products/product-044/image-01-1600-9e355564c027.webp",
              "width": 1600,
              "height": 2133
            }
          ]
        },
        {
          "label": "侧面",
          "alt": "保险柜，侧面实拍图",
          "width": 1600,
          "height": 2133,
          "src": "/products/product-044/image-02-960-ca00a686f2f5.webp",
          "srcSet": "/products/product-044/image-02-480-4df0b40afdbe.webp 480w, /products/product-044/image-02-960-ca00a686f2f5.webp 960w, /products/product-044/image-02-1600-5ed268d03f15.webp 1600w",
          "sources": [
            {
              "src": "/products/product-044/image-02-480-4df0b40afdbe.webp",
              "width": 480,
              "height": 640
            },
            {
              "src": "/products/product-044/image-02-960-ca00a686f2f5.webp",
              "width": 960,
              "height": 1280
            },
            {
              "src": "/products/product-044/image-02-1600-5ed268d03f15.webp",
              "width": 1600,
              "height": 2133
            }
          ]
        }
      ]
    },
    {
      "id": "product-045",
      "name": "冰箱空调",
      "categoryId": "home-life",
      "sourceDirectory": "冰箱空调",
      "images": [
        {
          "label": "正面",
          "alt": "冰箱空调，正面实拍图",
          "width": 1600,
          "height": 2133,
          "src": "/products/product-045/image-01-960-02fd9a7ac50b.webp",
          "srcSet": "/products/product-045/image-01-480-0c9aeafaf0fb.webp 480w, /products/product-045/image-01-960-02fd9a7ac50b.webp 960w, /products/product-045/image-01-1600-69c872baf619.webp 1600w",
          "sources": [
            {
              "src": "/products/product-045/image-01-480-0c9aeafaf0fb.webp",
              "width": 480,
              "height": 640
            },
            {
              "src": "/products/product-045/image-01-960-02fd9a7ac50b.webp",
              "width": 960,
              "height": 1280
            },
            {
              "src": "/products/product-045/image-01-1600-69c872baf619.webp",
              "width": 1600,
              "height": 2133
            }
          ]
        },
        {
          "label": "侧面",
          "alt": "冰箱空调，侧面实拍图",
          "width": 1600,
          "height": 2133,
          "src": "/products/product-045/image-02-960-91e9adc5d312.webp",
          "srcSet": "/products/product-045/image-02-480-d0e07e8a7805.webp 480w, /products/product-045/image-02-960-91e9adc5d312.webp 960w, /products/product-045/image-02-1600-f84b73cc8139.webp 1600w",
          "sources": [
            {
              "src": "/products/product-045/image-02-480-d0e07e8a7805.webp",
              "width": 480,
              "height": 640
            },
            {
              "src": "/products/product-045/image-02-960-91e9adc5d312.webp",
              "width": 960,
              "height": 1280
            },
            {
              "src": "/products/product-045/image-02-1600-f84b73cc8139.webp",
              "width": 1600,
              "height": 2133
            }
          ]
        }
      ]
    },
    {
      "id": "product-046",
      "name": "电视",
      "categoryId": "home-life",
      "sourceDirectory": "电视",
      "images": [
        {
          "label": "正面",
          "alt": "电视，正面实拍图",
          "width": 1600,
          "height": 1200,
          "src": "/products/product-046/image-01-960-5f796b41d648.webp",
          "srcSet": "/products/product-046/image-01-480-02cde320cce0.webp 480w, /products/product-046/image-01-960-5f796b41d648.webp 960w, /products/product-046/image-01-1600-9fb65e6ef0cb.webp 1600w",
          "sources": [
            {
              "src": "/products/product-046/image-01-480-02cde320cce0.webp",
              "width": 480,
              "height": 360
            },
            {
              "src": "/products/product-046/image-01-960-5f796b41d648.webp",
              "width": 960,
              "height": 720
            },
            {
              "src": "/products/product-046/image-01-1600-9fb65e6ef0cb.webp",
              "width": 1600,
              "height": 1200
            }
          ]
        },
        {
          "label": "侧面",
          "alt": "电视，侧面实拍图",
          "width": 1600,
          "height": 1200,
          "src": "/products/product-046/image-02-960-3ab77046dd1b.webp",
          "srcSet": "/products/product-046/image-02-480-04df7a0c281d.webp 480w, /products/product-046/image-02-960-3ab77046dd1b.webp 960w, /products/product-046/image-02-1600-ad2111d7fbde.webp 1600w",
          "sources": [
            {
              "src": "/products/product-046/image-02-480-04df7a0c281d.webp",
              "width": 480,
              "height": 360
            },
            {
              "src": "/products/product-046/image-02-960-3ab77046dd1b.webp",
              "width": 960,
              "height": 720
            },
            {
              "src": "/products/product-046/image-02-1600-ad2111d7fbde.webp",
              "width": 1600,
              "height": 1200
            }
          ]
        }
      ]
    },
    {
      "id": "product-047",
      "name": "麻将桌",
      "categoryId": "home-life",
      "sourceDirectory": "麻将桌",
      "images": [
        {
          "label": "正面",
          "alt": "麻将桌，正面实拍图",
          "width": 1600,
          "height": 2133,
          "src": "/products/product-047/image-01-960-d28ff1e26fb7.webp",
          "srcSet": "/products/product-047/image-01-480-e65d7b1dca0f.webp 480w, /products/product-047/image-01-960-d28ff1e26fb7.webp 960w, /products/product-047/image-01-1600-9822f897286b.webp 1600w",
          "sources": [
            {
              "src": "/products/product-047/image-01-480-e65d7b1dca0f.webp",
              "width": 480,
              "height": 640
            },
            {
              "src": "/products/product-047/image-01-960-d28ff1e26fb7.webp",
              "width": 960,
              "height": 1280
            },
            {
              "src": "/products/product-047/image-01-1600-9822f897286b.webp",
              "width": 1600,
              "height": 2133
            }
          ]
        },
        {
          "label": "侧面",
          "alt": "麻将桌，侧面实拍图",
          "width": 1600,
          "height": 1200,
          "src": "/products/product-047/image-02-960-3e9572e66d80.webp",
          "srcSet": "/products/product-047/image-02-480-4d0ee423958f.webp 480w, /products/product-047/image-02-960-3e9572e66d80.webp 960w, /products/product-047/image-02-1600-b04b9909522c.webp 1600w",
          "sources": [
            {
              "src": "/products/product-047/image-02-480-4d0ee423958f.webp",
              "width": 480,
              "height": 360
            },
            {
              "src": "/products/product-047/image-02-960-3e9572e66d80.webp",
              "width": 960,
              "height": 720
            },
            {
              "src": "/products/product-047/image-02-1600-b04b9909522c.webp",
              "width": 1600,
              "height": 1200
            }
          ]
        }
      ]
    },
    {
      "id": "product-048",
      "name": "手提电脑",
      "categoryId": "home-life",
      "sourceDirectory": "手提电脑",
      "images": [
        {
          "label": "打开",
          "alt": "手提电脑，打开实拍图",
          "width": 1600,
          "height": 1200,
          "src": "/products/product-048/image-01-960-5bc454e08e4e.webp",
          "srcSet": "/products/product-048/image-01-480-fda2e817dc22.webp 480w, /products/product-048/image-01-960-5bc454e08e4e.webp 960w, /products/product-048/image-01-1600-8c075805cc59.webp 1600w",
          "sources": [
            {
              "src": "/products/product-048/image-01-480-fda2e817dc22.webp",
              "width": 480,
              "height": 360
            },
            {
              "src": "/products/product-048/image-01-960-5bc454e08e4e.webp",
              "width": 960,
              "height": 720
            },
            {
              "src": "/products/product-048/image-01-1600-8c075805cc59.webp",
              "width": 1600,
              "height": 1200
            }
          ]
        },
        {
          "label": "闭合",
          "alt": "手提电脑，闭合实拍图",
          "width": 1600,
          "height": 2133,
          "src": "/products/product-048/image-02-960-46de2d72381a.webp",
          "srcSet": "/products/product-048/image-02-480-0a31d3a9310d.webp 480w, /products/product-048/image-02-960-46de2d72381a.webp 960w, /products/product-048/image-02-1600-e50bf72f2030.webp 1600w",
          "sources": [
            {
              "src": "/products/product-048/image-02-480-0a31d3a9310d.webp",
              "width": 480,
              "height": 640
            },
            {
              "src": "/products/product-048/image-02-960-46de2d72381a.webp",
              "width": 960,
              "height": 1280
            },
            {
              "src": "/products/product-048/image-02-1600-e50bf72f2030.webp",
              "width": 1600,
              "height": 2133
            }
          ]
        }
      ]
    },
    {
      "id": "product-049",
      "name": "洗衣机",
      "categoryId": "home-life",
      "sourceDirectory": "洗衣机",
      "images": [
        {
          "label": "正面",
          "alt": "洗衣机，正面实拍图",
          "width": 1600,
          "height": 1200,
          "src": "/products/product-049/image-01-960-ae10ad25b88c.webp",
          "srcSet": "/products/product-049/image-01-480-9f78e22e1f37.webp 480w, /products/product-049/image-01-960-ae10ad25b88c.webp 960w, /products/product-049/image-01-1600-62738df2c4d2.webp 1600w",
          "sources": [
            {
              "src": "/products/product-049/image-01-480-9f78e22e1f37.webp",
              "width": 480,
              "height": 360
            },
            {
              "src": "/products/product-049/image-01-960-ae10ad25b88c.webp",
              "width": 960,
              "height": 720
            },
            {
              "src": "/products/product-049/image-01-1600-62738df2c4d2.webp",
              "width": 1600,
              "height": 1200
            }
          ]
        },
        {
          "label": "侧面",
          "alt": "洗衣机，侧面实拍图",
          "width": 1600,
          "height": 2133,
          "src": "/products/product-049/image-02-960-185bf553e6d8.webp",
          "srcSet": "/products/product-049/image-02-480-c8ecaa9d3f9d.webp 480w, /products/product-049/image-02-960-185bf553e6d8.webp 960w, /products/product-049/image-02-1600-168d24637319.webp 1600w",
          "sources": [
            {
              "src": "/products/product-049/image-02-480-c8ecaa9d3f9d.webp",
              "width": 480,
              "height": 640
            },
            {
              "src": "/products/product-049/image-02-960-185bf553e6d8.webp",
              "width": 960,
              "height": 1280
            },
            {
              "src": "/products/product-049/image-02-1600-168d24637319.webp",
              "width": 1600,
              "height": 2133
            }
          ]
        }
      ]
    },
    {
      "id": "product-050",
      "name": "摇摇椅",
      "categoryId": "home-life",
      "sourceDirectory": "摇摇椅",
      "images": [
        {
          "label": "正面",
          "alt": "摇摇椅，正面实拍图",
          "width": 1600,
          "height": 2133,
          "src": "/products/product-050/image-01-960-c9fbb1df5e7f.webp",
          "srcSet": "/products/product-050/image-01-480-e07055d0d926.webp 480w, /products/product-050/image-01-960-c9fbb1df5e7f.webp 960w, /products/product-050/image-01-1600-764708e91b51.webp 1600w",
          "sources": [
            {
              "src": "/products/product-050/image-01-480-e07055d0d926.webp",
              "width": 480,
              "height": 640
            },
            {
              "src": "/products/product-050/image-01-960-c9fbb1df5e7f.webp",
              "width": 960,
              "height": 1280
            },
            {
              "src": "/products/product-050/image-01-1600-764708e91b51.webp",
              "width": 1600,
              "height": 2133
            }
          ]
        },
        {
          "label": "侧面",
          "alt": "摇摇椅，侧面实拍图",
          "width": 1600,
          "height": 2133,
          "src": "/products/product-050/image-02-960-696ca2bb5acc.webp",
          "srcSet": "/products/product-050/image-02-480-54e1d8a5349b.webp 480w, /products/product-050/image-02-960-696ca2bb5acc.webp 960w, /products/product-050/image-02-1600-4279b275492c.webp 1600w",
          "sources": [
            {
              "src": "/products/product-050/image-02-480-54e1d8a5349b.webp",
              "width": 480,
              "height": 640
            },
            {
              "src": "/products/product-050/image-02-960-696ca2bb5acc.webp",
              "width": 960,
              "height": 1280
            },
            {
              "src": "/products/product-050/image-02-1600-4279b275492c.webp",
              "width": 1600,
              "height": 2133
            }
          ]
        }
      ]
    },
    {
      "id": "product-051",
      "name": "衣服鞋子",
      "categoryId": "home-life",
      "sourceDirectory": "衣服鞋子",
      "images": [
        {
          "label": "正面",
          "alt": "衣服鞋子，正面实拍图",
          "width": 1600,
          "height": 1200,
          "src": "/products/product-051/image-01-960-63df0fe113f2.webp",
          "srcSet": "/products/product-051/image-01-480-5d9f0eb4c89a.webp 480w, /products/product-051/image-01-960-63df0fe113f2.webp 960w, /products/product-051/image-01-1600-dc3bf9989ebe.webp 1600w",
          "sources": [
            {
              "src": "/products/product-051/image-01-480-5d9f0eb4c89a.webp",
              "width": 480,
              "height": 360
            },
            {
              "src": "/products/product-051/image-01-960-63df0fe113f2.webp",
              "width": 960,
              "height": 720
            },
            {
              "src": "/products/product-051/image-01-1600-dc3bf9989ebe.webp",
              "width": 1600,
              "height": 1200
            }
          ]
        },
        {
          "label": "侧面",
          "alt": "衣服鞋子，侧面实拍图",
          "width": 1600,
          "height": 2133,
          "src": "/products/product-051/image-02-960-56170e7da3d2.webp",
          "srcSet": "/products/product-051/image-02-480-a03971a2735a.webp 480w, /products/product-051/image-02-960-56170e7da3d2.webp 960w, /products/product-051/image-02-1600-1b0239d4352e.webp 1600w",
          "sources": [
            {
              "src": "/products/product-051/image-02-480-a03971a2735a.webp",
              "width": 480,
              "height": 640
            },
            {
              "src": "/products/product-051/image-02-960-56170e7da3d2.webp",
              "width": 960,
              "height": 1280
            },
            {
              "src": "/products/product-051/image-02-1600-1b0239d4352e.webp",
              "width": 1600,
              "height": 2133
            }
          ]
        }
      ]
    },
    {
      "id": "product-052",
      "name": "发财灯",
      "categoryId": "ceremonial",
      "sourceDirectory": "发财灯",
      "images": [
        {
          "label": "正面",
          "alt": "发财灯，正面实拍图",
          "width": 1600,
          "height": 1200,
          "src": "/products/product-052/image-01-960-11b6e123f290.webp",
          "srcSet": "/products/product-052/image-01-480-76519fbac3f6.webp 480w, /products/product-052/image-01-960-11b6e123f290.webp 960w, /products/product-052/image-01-1600-452c4b3753a0.webp 1600w",
          "sources": [
            {
              "src": "/products/product-052/image-01-480-76519fbac3f6.webp",
              "width": 480,
              "height": 360
            },
            {
              "src": "/products/product-052/image-01-960-11b6e123f290.webp",
              "width": 960,
              "height": 720
            },
            {
              "src": "/products/product-052/image-01-1600-452c4b3753a0.webp",
              "width": 1600,
              "height": 1200
            }
          ]
        },
        {
          "label": "侧面",
          "alt": "发财灯，侧面实拍图",
          "width": 1600,
          "height": 2133,
          "src": "/products/product-052/image-02-960-891d1af0b302.webp",
          "srcSet": "/products/product-052/image-02-480-6e107894b444.webp 480w, /products/product-052/image-02-960-891d1af0b302.webp 960w, /products/product-052/image-02-1600-7f01463116c4.webp 1600w",
          "sources": [
            {
              "src": "/products/product-052/image-02-480-6e107894b444.webp",
              "width": 480,
              "height": 640
            },
            {
              "src": "/products/product-052/image-02-960-891d1af0b302.webp",
              "width": 960,
              "height": 1280
            },
            {
              "src": "/products/product-052/image-02-1600-7f01463116c4.webp",
              "width": 1600,
              "height": 2133
            }
          ]
        }
      ]
    },
    {
      "id": "product-053",
      "name": "金童玉女",
      "categoryId": "ceremonial",
      "sourceDirectory": "金童玉女",
      "images": [
        {
          "label": "款式一",
          "alt": "金童玉女，款式一实拍图",
          "width": 1600,
          "height": 2174,
          "src": "/products/product-053/image-01-960-c9b05ff7e59a.webp",
          "srcSet": "/products/product-053/image-01-480-5cacddfa8145.webp 480w, /products/product-053/image-01-960-c9b05ff7e59a.webp 960w, /products/product-053/image-01-1600-684ae7f21c85.webp 1600w",
          "sources": [
            {
              "src": "/products/product-053/image-01-480-5cacddfa8145.webp",
              "width": 480,
              "height": 652
            },
            {
              "src": "/products/product-053/image-01-960-c9b05ff7e59a.webp",
              "width": 960,
              "height": 1304
            },
            {
              "src": "/products/product-053/image-01-1600-684ae7f21c85.webp",
              "width": 1600,
              "height": 2174
            }
          ]
        },
        {
          "label": "款式二",
          "alt": "金童玉女，款式二实拍图",
          "width": 1600,
          "height": 1588,
          "src": "/products/product-053/image-02-960-2b057cdf9573.webp",
          "srcSet": "/products/product-053/image-02-480-760f23f8d431.webp 480w, /products/product-053/image-02-960-2b057cdf9573.webp 960w, /products/product-053/image-02-1600-dfd80ceeae3f.webp 1600w",
          "sources": [
            {
              "src": "/products/product-053/image-02-480-760f23f8d431.webp",
              "width": 480,
              "height": 476
            },
            {
              "src": "/products/product-053/image-02-960-2b057cdf9573.webp",
              "width": 960,
              "height": 953
            },
            {
              "src": "/products/product-053/image-02-1600-dfd80ceeae3f.webp",
              "width": 1600,
              "height": 1588
            }
          ]
        }
      ]
    },
    {
      "id": "product-054",
      "name": "莲花",
      "categoryId": "ceremonial",
      "sourceDirectory": "莲花",
      "images": [
        {
          "label": "正面",
          "alt": "莲花，正面实拍图",
          "width": 1600,
          "height": 2133,
          "src": "/products/product-054/image-01-960-e10f30ad1a3c.webp",
          "srcSet": "/products/product-054/image-01-480-1577da1b6ec9.webp 480w, /products/product-054/image-01-960-e10f30ad1a3c.webp 960w, /products/product-054/image-01-1600-cf0cc993783e.webp 1600w",
          "sources": [
            {
              "src": "/products/product-054/image-01-480-1577da1b6ec9.webp",
              "width": 480,
              "height": 640
            },
            {
              "src": "/products/product-054/image-01-960-e10f30ad1a3c.webp",
              "width": 960,
              "height": 1280
            },
            {
              "src": "/products/product-054/image-01-1600-cf0cc993783e.webp",
              "width": 1600,
              "height": 2133
            }
          ]
        },
        {
          "label": "侧面",
          "alt": "莲花，侧面实拍图",
          "width": 1600,
          "height": 2133,
          "src": "/products/product-054/image-02-960-98af943c766f.webp",
          "srcSet": "/products/product-054/image-02-480-aba53a665cd5.webp 480w, /products/product-054/image-02-960-98af943c766f.webp 960w, /products/product-054/image-02-1600-77c7ac7a62fd.webp 1600w",
          "sources": [
            {
              "src": "/products/product-054/image-02-480-aba53a665cd5.webp",
              "width": 480,
              "height": 640
            },
            {
              "src": "/products/product-054/image-02-960-98af943c766f.webp",
              "width": 960,
              "height": 1280
            },
            {
              "src": "/products/product-054/image-02-1600-77c7ac7a62fd.webp",
              "width": 1600,
              "height": 2133
            }
          ]
        }
      ]
    },
    {
      "id": "product-055",
      "name": "事事如意",
      "categoryId": "ceremonial",
      "sourceDirectory": "事事如意",
      "images": [
        {
          "label": "正面",
          "alt": "事事如意，正面实拍图",
          "width": 1600,
          "height": 2133,
          "src": "/products/product-055/image-01-960-c363b24cd20b.webp",
          "srcSet": "/products/product-055/image-01-480-7b3d29bbc5a2.webp 480w, /products/product-055/image-01-960-c363b24cd20b.webp 960w, /products/product-055/image-01-1600-1b424dcef8f6.webp 1600w",
          "sources": [
            {
              "src": "/products/product-055/image-01-480-7b3d29bbc5a2.webp",
              "width": 480,
              "height": 640
            },
            {
              "src": "/products/product-055/image-01-960-c363b24cd20b.webp",
              "width": 960,
              "height": 1280
            },
            {
              "src": "/products/product-055/image-01-1600-1b424dcef8f6.webp",
              "width": 1600,
              "height": 2133
            }
          ]
        },
        {
          "label": "侧面",
          "alt": "事事如意，侧面实拍图",
          "width": 1600,
          "height": 2133,
          "src": "/products/product-055/image-02-960-78583484b82f.webp",
          "srcSet": "/products/product-055/image-02-480-1641669cb9e3.webp 480w, /products/product-055/image-02-960-78583484b82f.webp 960w, /products/product-055/image-02-1600-b2501fa5bc1a.webp 1600w",
          "sources": [
            {
              "src": "/products/product-055/image-02-480-1641669cb9e3.webp",
              "width": 480,
              "height": 640
            },
            {
              "src": "/products/product-055/image-02-960-78583484b82f.webp",
              "width": 960,
              "height": 1280
            },
            {
              "src": "/products/product-055/image-02-1600-b2501fa5bc1a.webp",
              "width": 1600,
              "height": 2133
            }
          ]
        }
      ]
    },
    {
      "id": "product-056",
      "name": "五七花",
      "categoryId": "ceremonial",
      "sourceDirectory": "五七花",
      "images": [
        {
          "label": "正面",
          "alt": "五七花，正面实拍图",
          "width": 1600,
          "height": 1200,
          "src": "/products/product-056/image-01-960-b151e62efdb4.webp",
          "srcSet": "/products/product-056/image-01-480-90640ac89572.webp 480w, /products/product-056/image-01-960-b151e62efdb4.webp 960w, /products/product-056/image-01-1600-e89bbed58d30.webp 1600w",
          "sources": [
            {
              "src": "/products/product-056/image-01-480-90640ac89572.webp",
              "width": 480,
              "height": 360
            },
            {
              "src": "/products/product-056/image-01-960-b151e62efdb4.webp",
              "width": 960,
              "height": 720
            },
            {
              "src": "/products/product-056/image-01-1600-e89bbed58d30.webp",
              "width": 1600,
              "height": 1200
            }
          ]
        },
        {
          "label": "侧面",
          "alt": "五七花，侧面实拍图",
          "width": 1600,
          "height": 1200,
          "src": "/products/product-056/image-02-960-edcedf3281a1.webp",
          "srcSet": "/products/product-056/image-02-480-c27704c2a9ed.webp 480w, /products/product-056/image-02-960-edcedf3281a1.webp 960w, /products/product-056/image-02-1600-c5a8b3a4d7a5.webp 1600w",
          "sources": [
            {
              "src": "/products/product-056/image-02-480-c27704c2a9ed.webp",
              "width": 480,
              "height": 360
            },
            {
              "src": "/products/product-056/image-02-960-edcedf3281a1.webp",
              "width": 960,
              "height": 720
            },
            {
              "src": "/products/product-056/image-02-1600-c5a8b3a4d7a5.webp",
              "width": 1600,
              "height": 1200
            }
          ]
        }
      ]
    },
    {
      "id": "product-057",
      "name": "香柏、元宝及各种贡品",
      "categoryId": "sets",
      "sourceDirectory": "香柏元胞各种贡品",
      "images": [
        {
          "label": "正面",
          "alt": "香柏、元宝及各种贡品，正面实拍图",
          "width": 1600,
          "height": 1200,
          "src": "/products/product-057/image-01-960-ec0af11412a7.webp",
          "srcSet": "/products/product-057/image-01-480-31de0e9ee287.webp 480w, /products/product-057/image-01-960-ec0af11412a7.webp 960w, /products/product-057/image-01-1600-b3afc26cf731.webp 1600w",
          "sources": [
            {
              "src": "/products/product-057/image-01-480-31de0e9ee287.webp",
              "width": 480,
              "height": 360
            },
            {
              "src": "/products/product-057/image-01-960-ec0af11412a7.webp",
              "width": 960,
              "height": 720
            },
            {
              "src": "/products/product-057/image-01-1600-b3afc26cf731.webp",
              "width": 1600,
              "height": 1200
            }
          ]
        },
        {
          "label": "侧面",
          "alt": "香柏、元宝及各种贡品，侧面实拍图",
          "width": 1600,
          "height": 1200,
          "src": "/products/product-057/image-02-960-4046487ab70a.webp",
          "srcSet": "/products/product-057/image-02-480-76d2373bff4b.webp 480w, /products/product-057/image-02-960-4046487ab70a.webp 960w, /products/product-057/image-02-1600-dcab39ca3785.webp 1600w",
          "sources": [
            {
              "src": "/products/product-057/image-02-480-76d2373bff4b.webp",
              "width": 480,
              "height": 360
            },
            {
              "src": "/products/product-057/image-02-960-4046487ab70a.webp",
              "width": 960,
              "height": 720
            },
            {
              "src": "/products/product-057/image-02-1600-dcab39ca3785.webp",
              "width": 1600,
              "height": 1200
            }
          ]
        }
      ]
    }
  ],
  "heroProductId": "product-015",
  "productCount": 57,
  "imageCount": 109
} as const;
// CATALOG_DATA_END

export const categories: readonly Category[] = catalogData.categories;
export const products: readonly Product[] = catalogData.products;
export const heroProductId = catalogData.heroProductId;
export const productCount = catalogData.productCount;
export const imageCount = catalogData.imageCount;

export const catalog = {
  categories,
  products,
  heroProductId,
  productCount,
  imageCount,
} as const;

export default catalog;
